// File generated by salient-types.
// @ts-nocheck
export enum InputMode {
    NONE = 0,
    SERVO = 1,
    CAN = 2,
    USB = 3,
}

export enum ControlMode {
    TORQUE = 0,
    SPEED = 1,
    VOLTAGE = 2,
    POSITION = 3,
}

export enum ControllerState {
    BOOT = 0,
    CALIBRATION = 1,
    L_R_DETECTION = 2,
    ENCODER_DETECTION = 3,
    STOPPED = 4,
    RUNNING = 5,
    TEST = 6,
    UPDATING_FIRMWARE = 7,
    FAULT = 8,
    HALL_SENSOR_DETECTION = 9,
}

export enum FaultCode {
    NO_FAULT = 0,
    BAD_CALIBRATION_CURRENT_MEASURE = 1,
    VOLTAGE_OUT_OF_RANGE_CRITICAL = 2,
    OVERTEMPERATURE = 3,
    OVERCURRENT_CRITICAL = 4,
    BAD_CONFIG = 5,
    GATE_DRIVE_UNDERVOLTAGE = 6,
    LOGIC_UNDERVOLTAGE_Deprecated = 7,
    PARAM_DETECT_FAIL = 8,
    NAN_OUTPUT_PHASE_VOLTAGE = 9,
    BAD_PARAM_Deprecated = 10,
    INPUT_TIMEOUT = 11,
    ENCODER_CALIBRATION_FAILED = 12,
    GATE_DRIVE_OVERCURRENT = 13,
    GATE_DRIVE_FAULT = 14,
    GATE_DRIVE_OVERTEMPERATURE_SHUTDOWN = 15,
    GATE_DRIVE_OVERTEMPERATURE_WARNING = 16,
    GATE_DRIVE_CHARGE_PUMP_VGLS_UNDERVOLTAGE = 17,
    GATE_DRIVE_INIT_FAILED = 18,
    HALL_SENSOR_CALIBRATION_FAILED = 19,
    VOLTAGE_OUT_OF_RANGE_WARNING = 20,
    OVERCURRENT_WARNING = 21,
    OVERLOAD_CRITICAL = 22,
    DC_OVERCURRENT_CRITICAL = 23,
    NULL_KEYSTORE_CALLBACK = 24,
    CRC_32_MISMATCH = 25,
}

export enum SensorMode {
    SENSORLESS = 0,
    ENCODER = 1,
    OPENLOOP = 2,
    HALLSENSOR = 3,
    ABSOLUTE_ENCODER = 4,
}

export enum HallsensorCalibStatus {
    UNKNOWN = 0,
    COMPLETE = 1,
    ONGOING = 2,
    FAILURE_TIMEOUT = 3,
    FAILURE_ABORTED = 4,
}

export enum EncoderCalibStatus {
    UNKNOWN = 0,
    COMPLETE = 1,
    ONGOING = 2,
    FAILURE_INDEX_MISSING = 3,
    FAILURE_POSITION_ERROR = 4,
    FAILURE_TIMEOUT = 5,
    FAILURE_ABORTED = 6,
}

export enum AbsoluteEncoderCalibStatus {
    UNKNOWN = 0,
    COMPLETE = 1,
    ONGOING = 2,
    FAILURE_INDEX_MISSING = 3,
    FAILURE_POSITION_ERROR = 4,
    FAILURE_TIMEOUT = 5,
    FAILURE_ABORTED = 6,
}

export enum HomingCalibStatus {
    UNKNOWN = 0,
    SUCCESS = 1,
    IN_PROGRESS = 2,
    FAILURE_TIMEOUT = 3,
    FAILURE_NO_STALL = 4,
    FAILURE_NOT_FREEWHEEL = 5,
}

export enum SensorCalibState {
    IDLE = 0,
    FWD = 1,
    REV = 2,
    STOP_MOTION = 3,
    COMPUTE_OFFSET = 4,
    ABORTED = 5,
}

export enum SmFwBuildType {
    EXPERIMENTAL = 0,
    CANDIDATE = 1,
    RELEASE = 2,
}

export enum GearRatioCalStatus {
    IDLE = 0,
    RUNNING = 1,
    COMPLETE = 2,
    FAILED_TIMEOUT = 3,
    FAILED_NO_MOTION = 4,
    FAILED_LOW_QUALITY = 5,
}
export enum AbsoluteEncoderDirection {
    COUNT_DOWN = -1,
    UNKNOWN = 0,
    COUNT_UP = 1,
}

export enum EncoderDirection {
    COUNT_DOWN = -1,
    UNKNOWN = 0,
    COUNT_UP = 1,
}

export enum HallsensorDirection {
    REVERSE = -1,
    UNKNOWN = 0,
    FORWARD = 1,
}

export enum FluxWeakening {
    UNKNOWN = -1,
    DISABLE = 0,
    ENABLE = 1,
}

export enum Mtpa {
    UNKNOWN = -1,
    DISABLE = 0,
    ENABLE = 1,
}

export enum PositionType {
    UNKNOWN = -1,
    ROTATIONAL = 0,
    LINEAR = 1,
}

export enum PositionUnits {
    UNKNOWN = -1,
    RADIANS = 0,
    DEGREES = 1,
    MILLIMETERS = 2,
    INCHES = 3,
}

export enum PositionResolution {
    UNKNOWN = -1,
    VALUE_1E0 = 0,
    VALUE_1E1 = 1,
    VALUE_1E2 = 2,
    VALUE_1E3 = 3,
}

export enum CertExchangeResult {
    SUCCESS = 0,
    BAD_CHALLENGE_STEP = 1,
    KEY_NOT_FOUND = 2,
    BAD_SIGNATURE = 3,
}

export enum EncChallengeResult {
    SUCCESS = 0,
    BAD_CHALLENGE_STEP = 1,
    BAD_DECRYPTION = 2,
}

export enum AuthStatus {
    AUTHENTICATED = 0,
    NEEDS_REAUTH = 1,
}

export enum CanopenErrorCode {
    DEPRECATED = 65281,
    BAD_CALIBRATION_CURRENT_MEASURE = 65282,
    GATE_DRIVE_UNDERVOLTAGE = 65283,
    ENCODER_CALIBRATION_FAILED = 65284,
    INPUT_TIMEOUT = 65285,
    GATE_DRIVE_FAULT = 65286,
    GATE_DRIVE_OVERTEMPERATURE_SHUTDOWN = 65287,
    GATE_DRIVE_OVERTEMPERATURE_WARNING = 65288,
    GATE_DRIVE_CHARGE_PUMP_UNDERVOLTAGE = 65289,
    GATE_DRIVE_INIT_FAILED = 65290,
    CRITICAL_OVERLOAD = 65291,
    OUT_OF_WINDOW_VOLTAGE_WARNING = 65292,
    OUT_OF_WINDOW_VOLTAGE_CRITICAL = 65293,
    OVERCURRENT_WARNING = 65294,
    BAD_CONFIGURATION = 65295,
    GATE_DRIVE_OVERCURRENT = 65296,
    OVERCURRENT_CRITICAL = 65297,
    NAN_OUTPUT_PHASE_VOLTAGE = 65298,
    PARAM_DETECT_FAIL = 65299,
    HALL_SENSOR_CALIBRATION_FAILED = 65300,
}

export enum PacketId {
    INVALID = 0,
    HANDSHAKE = 1,
    START_PARAM_DETECT = 2,
    WRITE_INPUT_CONFIG = 3,
    WRITE_POWER_CONFIG = 4,
    READ_FAULT = 5,
    READ_TELEMETRY = 6,
    READ_MOTOR_PARAM = 7,
    READ_INPUT_CONFIG = 8,
    READ_POWER_CONFIG = 9,
    WRITE_PARAMETERS = 10,
    WRITE_CONTROL_CONFIG = 11,
    WRITE_SENSOR_MODE = 12,
    READ_SENSOR_MODE = 13,
    START_ENCODER_CAL = 14,
    GET_ENCODER_CAL_RESULT = 15,
    ENCODER_CAL_RESULT = 16,
    WRITE_OPEN_LOOP_CONFIG = 17,
    READ_CONTROL_MODE = 18,
    WRITE_CAN_ID = 19,
    READ_CAN_ID = 20,
    WRITE_ESC_ID = 21,
    READ_ESC_ID = 22,
    GET_BUILD_INFO = 23,
    READ_MTPA_STATUS = 24,
    READ_FLUX_WEAKENING_STATUS = 25,
    WRITE_POSITION_CONTROL_SETTINGS = 26,
    READ_POSITION_CONTROL_SETTINGS = 27,
    SET_POSITION_SENSOR_LIMITS = 28,
    READ_POSITION_SENSOR_LIMITS = 29,
    START_HALL_SENSOR_CAL = 30,
    GET_HALL_SENSOR_CAL_RESULT = 31,
    HALL_SENSOR_CAL_RESULT = 32,
    CLEAR_ALL_FAULTS = 33,
    CERT_EXCHANGE_1 = 34,
    CERT_EXCHANGE_2 = 35,
    ENC_CHALLENGE_1 = 36,
    ENC_CHALLENGE_2 = 37,
    KEEP_ALIVE = 38,
    KEY_CONFIG = 39,
    START_HOMING_CAL = 40,
    HOMING_CAL_RESULT = 41,
    START_SYSID = 42,
    STOP_SYSID = 43,
    ZERO_DARE_SENSOR = 44,
    READ_TOTAL_ACTUATORS = 45,
    ACTUATOR_INFO = 46,
    SET_CONTROL_MODE = 47,
    SET_USB_THROTTLE_CONTROL = 64,
    FAULT_DATA = 127,
    REALTIME_DATA = 128,
    VARIABLE_TELEMETRY = 129,
    MULTI_MOTOR_TELEMETRY = 130,
    FIRMWARE_UPDATE = 254,
    USER_DEFINED = 255,
}

export interface IInvalidRequest {
}

export interface IInvalidResponse {
}

export interface IHandshakeRequest {
}

export interface IHandshakeResponse {
    versionMajor: number;
    versionMinor: number;
    versionBuild: number;
    resistance: number;
    ld: number;
    lq: number;
    fluxLinkage: number;
    gitHash: number;
    deviceId1: number;
    deviceId2: number;
    deviceId3: number;
}

export interface IStartParamDetectRequest {
    paramDetectMaxCurrent: number;
    paramDetectMaxRpm: number;
}

export interface IStartParamDetectResponse {
    resistance: number;
    ld: number;
    lq: number;
    fluxLinkage: number;
}

export interface IWriteInputConfigRequest {
    inputLimitUpper: number;
    inputLimitLower: number;
    inputLimitCenter: number;
    inputMode: InputMode;
    alwaysOn: number;
}

export interface IWriteInputConfigResponse {
    inputLimitUpper: number;
    inputLimitLower: number;
    inputLimitCenter: number;
    inputMode: InputMode;
    alwaysOn: number;
}

export interface IWritePowerConfigRequest {
    motorCurrentLimit: number;
    batteryCurrentLimit: number;
    criticalOvervoltageThreshold: number;
    criticalUndervoltageThreshold: number;
    overcurrentThresholdDeprecated: number;
    overtemperatureThreshold: number;
    warningOvervoltageThreshold: number;
    warningUndervoltageThreshold: number;
    warningMotorCurrentThreshold: number;
    criticalMotorCurrentThreshold: number;
}

export interface IWritePowerConfigResponse {
    motorCurrentLimit: number;
    batteryCurrentLimit: number;
    criticalOvervoltageThreshold: number;
    criticalUndervoltageThreshold: number;
    overcurrentThresholdDeprecated: number;
    overtemperatureThreshold: number;
    warningOvervoltageThreshold: number;
    warningUndervoltageThreshold: number;
    warningMotorCurrentThreshold: number;
    criticalMotorCurrentThreshold: number;
}

export interface IReadFaultRequest {
}

export interface IReadFaultResponse {
}

export interface IReadTelemetryRequest {
}

export interface IReadTelemetryResponse {
}

export interface IReadMotorParamRequest {
}

export interface IReadMotorParamResponse {
}

export interface IReadInputConfigRequest {
}

export interface IReadInputConfigResponse {
    inputLimitUpper: number;
    inputLimitLower: number;
    inputLimitCenter: number;
    inputMode: InputMode;
    alwaysOn: number;
}

export interface IReadPowerConfigRequest {
}

export interface IReadPowerConfigResponse {
    motorCurrentLimit: number;
    batteryCurrentLimit: number;
    criticalOvervoltageThreshold: number;
    criticalUndervoltageThreshold: number;
    overcurrentThresholdDeprecated: number;
    overtemperatureThreshold: number;
    warningOvervoltageThreshold: number;
    warningUndervoltageThreshold: number;
    warningMotorCurrentThreshold: number;
    criticalMotorCurrentThreshold: number;
}

export interface IWriteParametersRequest {
    resistance: number;
    ld: number;
    lq: number;
    fluxLinkage: number;
}

export interface IWriteParametersResponse {
    resistance: number;
    ld: number;
    lq: number;
    fluxLinkage: number;
}

export interface IWriteControlConfigRequest {
    motorMaxSpeed: number;
    polePairCount: number;
    speedControlProportionalGain: number;
    speedControlIntegralGain: number;
    deprecatedPositionControlProportionalGain: number;
    controlMode: ControlMode;
    mtpa: Mtpa;
    fluxWeakening: FluxWeakening;
}

export interface IWriteControlConfigResponse {
    motorMaxSpeed: number;
    polePairCount: number;
    speedControlProportionalGain: number;
    speedControlIntegralGain: number;
    deprecatedPositionControlProportionalGain: number;
    controlMode: ControlMode;
    mtpa: Mtpa;
    fluxWeakening: FluxWeakening;
}

export interface IWriteSensorModeRequest {
    sensorMode: SensorMode;
    encoderCpr: number;
}

export interface IWriteSensorModeResponse {
    sensorMode: SensorMode;
    encoderCpr: number;
}

export interface IReadSensorModeRequest {
}

export interface IReadSensorModeResponse {
    sensorMode: SensorMode;
    encoderCpr: number;
    encoderOffset: number;
    encoderDirection: EncoderDirection;
    hallsensorForwardOffset: number;
    hallsensorReverseOffset: number;
    hallsensorDirection: HallsensorDirection;
}

export interface IStartEncoderCalRequest {
}

export interface IStartEncoderCalResponse {
}

export interface IGetEncoderCalResultRequest {
}

export interface IGetEncoderCalResultResponse {
    offset: number;
    status: EncoderCalibStatus;
    direction: EncoderDirection;
}

export interface IEncoderCalResultRequest {
}

export interface IEncoderCalResultResponse {
    offset: number;
    status: EncoderCalibStatus;
    direction: EncoderDirection;
}

export interface IWriteOpenLoopConfigRequest {
    accelerationRamp: number;
}

export interface IWriteOpenLoopConfigResponse {
    accelerationRamp: number;
}

export interface IReadControlModeRequest {
}

export interface IReadControlModeResponse {
    controlMode: ControlMode;
}

export interface IWriteCanIdRequest {
    canId: number;
}

export interface IWriteCanIdResponse {
    canId: number;
}

export interface IReadCanIdRequest {
}

export interface IReadCanIdResponse {
    canId: number;
}

export interface IWriteEscIdRequest {
    escIndex: number;
}

export interface IWriteEscIdResponse {
    escIndex: number;
}

export interface IReadEscIdRequest {
}

export interface IReadEscIdResponse {
    escIndex: number;
}

export interface IGetBuildInfoRequest {
}

export interface IGetBuildInfoResponse {
    year: number;
    month: number;
    day: number;
    increment: number;
    buildType: SmFwBuildType;
    dirty: number;
}

export interface IReadMtpaStatusRequest {
}

export interface IReadMtpaStatusResponse {
    mtpa: Mtpa;
}

export interface IReadFluxWeakeningStatusRequest {
}

export interface IReadFluxWeakeningStatusResponse {
    fluxWeakening: FluxWeakening;
}

export interface IWritePositionControlSettingsRequest {
    positionControlProportionalGain: number;
    positionControlIntegralGain: number;
    positionControlDerivGain: number;
    positionControlMaxSpeed: number;
    positionControlMaxAccel: number;
    positionControlDeadband: number;
    positionControlType: PositionType;
    positionUnits: PositionUnits;
    positionResolution: PositionResolution;
    travelDistance: number;
}

export interface IWritePositionControlSettingsResponse {
    positionControlProportionalGain: number;
    positionControlIntegralGain: number;
    positionControlDerivGain: number;
    positionControlMaxSpeed: number;
    positionControlMaxAccel: number;
    positionControlDeadband: number;
    positionControlType: PositionType;
    positionUnits: PositionUnits;
    positionResolution: PositionResolution;
    travelDistance: number;
}

export interface IReadPositionControlSettingsRequest {
}

export interface IReadPositionControlSettingsResponse {
    positionControlProportionalGain: number;
    positionControlIntegralGain: number;
    positionControlDerivGain: number;
    positionControlMaxSpeed: number;
    positionControlMaxAccel: number;
    positionControlDeadband: number;
    positionControlType: PositionType;
    positionUnits: PositionUnits;
    positionResolution: PositionResolution;
    travelDistance: number;
}

export interface ISetPositionSensorLimitsRequest {
    setCurrentPosToMin: number;
    setCurrentPosToMax: number;
}

export interface ISetPositionSensorLimitsResponse {
    minPosition: number;
    maxPosition: number;
}

export interface IReadPositionSensorLimitsRequest {
}

export interface IReadPositionSensorLimitsResponse {
    minValue: number;
    maxValue: number;
}

export interface IStartHallSensorCalRequest {
}

export interface IStartHallSensorCalResponse {
}

export interface IGetHallSensorCalResultRequest {
}

export interface IGetHallSensorCalResultResponse {
    forwardOffset: number;
    reverseOffset: number;
    status: HallsensorCalibStatus;
    direction: HallsensorDirection;
}

export interface IHallSensorCalResultRequest {
}

export interface IHallSensorCalResultResponse {
    forwardOffset: number;
    reverseOffset: number;
    status: HallsensorCalibStatus;
    direction: HallsensorDirection;
}

export interface IClearAllFaultsRequest {
}

export interface IClearAllFaultsResponse {
}

export interface ICertExchange1Request {
    sLabCertFirstHalf: Uint8Array | number[]; // 50 bytes
}

export interface ICertExchange1Response {
    mcuCertFirstHalf: Uint8Array | number[]; // 50 bytes
}

export interface ICertExchange2Request {
    sLabCertLastHalf: Uint8Array | number[]; // 50 bytes
}

export interface ICertExchange2Response {
    result: CertExchangeResult;
    mcuCertLastHalf: Uint8Array | number[]; // 50 bytes
}

export interface IEncChallenge1Request {
    challengeA: Uint8Array | number[]; // 16 bytes
}

export interface IEncChallenge1Response {
    encChallengeA: Uint8Array | number[]; // 16 bytes
    challengeB: Uint8Array | number[]; // 16 bytes
}

export interface IEncChallenge2Request {
    encChallengeB: Uint8Array | number[]; // 16 bytes
}

export interface IEncChallenge2Response {
    result: EncChallengeResult;
}

export interface IKeepAliveRequest {
}

export interface IKeepAliveResponse {
    authStatus: AuthStatus;
}

export interface IKeyConfigRequest {
    keyBytestream: Uint8Array | number[]; // 60 bytes
}

export interface IKeyConfigResponse {
    keyBytestreamRsp: Uint8Array | number[]; // 60 bytes
}

export interface IStartHomingCalRequest {
}

export interface IStartHomingCalResponse {
}

export interface IHomingCalResultRequest {
}

export interface IHomingCalResultResponse {
    zeroOffset: number;
    status: HomingCalibStatus;
}

export interface IStartSysidRequest {
}

export interface IStartSysidResponse {
}

export interface IStopSysidRequest {
}

export interface IStopSysidResponse {
}

export interface IZeroDareSensorRequest {
}

export interface IZeroDareSensorResponse {
    encoder0ZeroPos: number;
    encoder1ZeroPos: number;
}

export interface IReadTotalActuatorsRequest {
}

export interface IReadTotalActuatorsResponse {
    detectedNodes: number;
    expectedNodes: number;
    operationalNodesBitmap: number;
}

export interface IActuatorInfoRequest {
}

export interface IActuatorInfoResponse {
    nodeId: number;
    dispositionStr: Uint8Array | number[]; // 27 bytes
}

export interface ISetControlModeRequest {
    controlMode: ControlMode;
}

export interface ISetControlModeResponse {
    controlMode: ControlMode;
}

export interface ISetUsbThrottleControlRequest {
    value: number;
}

export interface ISetUsbThrottleControlResponse {
    value: number;
}

export interface IFaultDataMessage {
    code: number;
}

export interface IRealtimeDataMessage {
    motorSpeed: number;
    motorCurrent: number;
    batteryVoltage: number;
    batteryCurrent: number;
    servoPulse: number;
    inverterTemp: number;
    controllerState: ControllerState;
    faultCodeDeprecated: FaultCode;
    uptimeMs: number;
    motorPosition: number;
    positionSensorReading: number;
    faultsBitmapLower32: number;
    faultsBitmapUpper16: number;
    externalThermTemp: number;
    rawPositionSensor: number;
    sysidFrequency: number;
    sysidMagnitude: number;
}

export interface IVariableTelemetryMessage {
    telemId: number;
    telemBytestream: Uint8Array | number[]; // 59 bytes
}

export interface IMultiMotorTelemetryMessage {
    actuatorNodeId: number;
    faultsBitmapLower32: number;
    faultsBitmapUpper16: number;
    currentPosition: number;
    velocityActualValue: number;
    torqueActualValue: number;
    currentActualValue: number;
    targetPosition: number;
    statusWord: number;
    mosfetTemperature: number;
    batteryCurrent: number;
}

export interface IFirmwareUpdateRequest {
}

export interface IFirmwareUpdateResponse {
}

export interface IUserDefinedMessage {
}

export const serializeInvalidRequest = ( message: IInvalidRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.INVALID );
    return dv;
};

export const serializeInvalidResponse = ( message: IInvalidResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.INVALID );
    return dv;
};

export const serializeHandshakeRequest = ( message: IHandshakeRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.HANDSHAKE );
    return dv;
};

export const serializeHandshakeResponse = ( message: IHandshakeResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.HANDSHAKE );
    dv.setUint32( 4, message.versionMajor, true );
    dv.setUint32( 8, message.versionMinor, true );
    dv.setUint32( 12, message.versionBuild, true );
    dv.setFloat32( 16, message.resistance, true );
    dv.setFloat32( 20, message.ld, true );
    dv.setFloat32( 24, message.lq, true );
    dv.setFloat32( 28, message.fluxLinkage, true );
    dv.setUint32( 32, message.gitHash, true );
    dv.setUint32( 36, message.deviceId1, true );
    dv.setUint32( 40, message.deviceId2, true );
    dv.setUint32( 44, message.deviceId3, true );
    return dv;
};

export const serializeStartParamDetectRequest = ( message: IStartParamDetectRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.START_PARAM_DETECT );
    dv.setFloat32( 4, message.paramDetectMaxCurrent, true );
    dv.setFloat32( 8, message.paramDetectMaxRpm, true );
    return dv;
};

export const serializeStartParamDetectResponse = ( message: IStartParamDetectResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.START_PARAM_DETECT );
    dv.setFloat32( 4, message.resistance, true );
    dv.setFloat32( 8, message.ld, true );
    dv.setFloat32( 12, message.lq, true );
    dv.setFloat32( 16, message.fluxLinkage, true );
    return dv;
};

export const serializeWriteInputConfigRequest = ( message: IWriteInputConfigRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_INPUT_CONFIG );
    dv.setUint32( 4, message.inputLimitUpper, true );
    dv.setUint32( 8, message.inputLimitLower, true );
    dv.setUint32( 12, message.inputLimitCenter, true );
    dv.setUint8( 16, message.inputMode );
    dv.setUint8( 17, message.alwaysOn );
    return dv;
};

export const serializeWriteInputConfigResponse = ( message: IWriteInputConfigResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_INPUT_CONFIG );
    dv.setUint32( 4, message.inputLimitUpper, true );
    dv.setUint32( 8, message.inputLimitLower, true );
    dv.setUint32( 12, message.inputLimitCenter, true );
    dv.setUint8( 16, message.inputMode );
    dv.setUint8( 17, message.alwaysOn );
    return dv;
};

export const serializeWritePowerConfigRequest = ( message: IWritePowerConfigRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_POWER_CONFIG );
    dv.setFloat32( 4, message.motorCurrentLimit, true );
    dv.setFloat32( 8, message.batteryCurrentLimit, true );
    dv.setFloat32( 12, message.criticalOvervoltageThreshold, true );
    dv.setFloat32( 16, message.criticalUndervoltageThreshold, true );
    dv.setFloat32( 20, message.overcurrentThresholdDeprecated, true );
    dv.setFloat32( 24, message.overtemperatureThreshold, true );
    dv.setFloat32( 28, message.warningOvervoltageThreshold, true );
    dv.setFloat32( 32, message.warningUndervoltageThreshold, true );
    dv.setFloat32( 36, message.warningMotorCurrentThreshold, true );
    dv.setFloat32( 40, message.criticalMotorCurrentThreshold, true );
    return dv;
};

export const serializeWritePowerConfigResponse = ( message: IWritePowerConfigResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_POWER_CONFIG );
    dv.setFloat32( 4, message.motorCurrentLimit, true );
    dv.setFloat32( 8, message.batteryCurrentLimit, true );
    dv.setFloat32( 12, message.criticalOvervoltageThreshold, true );
    dv.setFloat32( 16, message.criticalUndervoltageThreshold, true );
    dv.setFloat32( 20, message.overcurrentThresholdDeprecated, true );
    dv.setFloat32( 24, message.overtemperatureThreshold, true );
    dv.setFloat32( 28, message.warningOvervoltageThreshold, true );
    dv.setFloat32( 32, message.warningUndervoltageThreshold, true );
    dv.setFloat32( 36, message.warningMotorCurrentThreshold, true );
    dv.setFloat32( 40, message.criticalMotorCurrentThreshold, true );
    return dv;
};

export const serializeReadFaultRequest = ( message: IReadFaultRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_FAULT );
    return dv;
};

export const serializeReadFaultResponse = ( message: IReadFaultResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_FAULT );
    return dv;
};

export const serializeReadTelemetryRequest = ( message: IReadTelemetryRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_TELEMETRY );
    return dv;
};

export const serializeReadTelemetryResponse = ( message: IReadTelemetryResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_TELEMETRY );
    return dv;
};

export const serializeReadMotorParamRequest = ( message: IReadMotorParamRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_MOTOR_PARAM );
    return dv;
};

export const serializeReadMotorParamResponse = ( message: IReadMotorParamResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_MOTOR_PARAM );
    return dv;
};

export const serializeReadInputConfigRequest = ( message: IReadInputConfigRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_INPUT_CONFIG );
    return dv;
};

export const serializeReadInputConfigResponse = ( message: IReadInputConfigResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_INPUT_CONFIG );
    dv.setUint32( 4, message.inputLimitUpper, true );
    dv.setUint32( 8, message.inputLimitLower, true );
    dv.setUint32( 12, message.inputLimitCenter, true );
    dv.setUint8( 16, message.inputMode );
    dv.setUint8( 17, message.alwaysOn );
    return dv;
};

export const serializeReadPowerConfigRequest = ( message: IReadPowerConfigRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_POWER_CONFIG );
    return dv;
};

export const serializeReadPowerConfigResponse = ( message: IReadPowerConfigResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_POWER_CONFIG );
    dv.setFloat32( 4, message.motorCurrentLimit, true );
    dv.setFloat32( 8, message.batteryCurrentLimit, true );
    dv.setFloat32( 12, message.criticalOvervoltageThreshold, true );
    dv.setFloat32( 16, message.criticalUndervoltageThreshold, true );
    dv.setFloat32( 20, message.overcurrentThresholdDeprecated, true );
    dv.setFloat32( 24, message.overtemperatureThreshold, true );
    dv.setFloat32( 28, message.warningOvervoltageThreshold, true );
    dv.setFloat32( 32, message.warningUndervoltageThreshold, true );
    dv.setFloat32( 36, message.warningMotorCurrentThreshold, true );
    dv.setFloat32( 40, message.criticalMotorCurrentThreshold, true );
    return dv;
};

export const serializeWriteParametersRequest = ( message: IWriteParametersRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_PARAMETERS );
    dv.setFloat32( 4, message.resistance, true );
    dv.setFloat32( 8, message.ld, true );
    dv.setFloat32( 12, message.lq, true );
    dv.setFloat32( 16, message.fluxLinkage, true );
    return dv;
};

export const serializeWriteParametersResponse = ( message: IWriteParametersResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_PARAMETERS );
    dv.setFloat32( 4, message.resistance, true );
    dv.setFloat32( 8, message.ld, true );
    dv.setFloat32( 12, message.lq, true );
    dv.setFloat32( 16, message.fluxLinkage, true );
    return dv;
};

export const serializeWriteControlConfigRequest = ( message: IWriteControlConfigRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_CONTROL_CONFIG );
    dv.setFloat32( 4, message.motorMaxSpeed, true );
    dv.setFloat32( 8, message.polePairCount, true );
    dv.setFloat32( 12, message.speedControlProportionalGain, true );
    dv.setFloat32( 16, message.speedControlIntegralGain, true );
    dv.setFloat32( 20, message.deprecatedPositionControlProportionalGain, true );
    dv.setUint8( 24, message.controlMode );
    dv.setInt8( 25, message.mtpa );
    dv.setInt8( 26, message.fluxWeakening );
    return dv;
};

export const serializeWriteControlConfigResponse = ( message: IWriteControlConfigResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_CONTROL_CONFIG );
    dv.setFloat32( 4, message.motorMaxSpeed, true );
    dv.setFloat32( 8, message.polePairCount, true );
    dv.setFloat32( 12, message.speedControlProportionalGain, true );
    dv.setFloat32( 16, message.speedControlIntegralGain, true );
    dv.setFloat32( 20, message.deprecatedPositionControlProportionalGain, true );
    dv.setUint8( 24, message.controlMode );
    dv.setInt8( 25, message.mtpa );
    dv.setInt8( 26, message.fluxWeakening );
    return dv;
};

export const serializeWriteSensorModeRequest = ( message: IWriteSensorModeRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_SENSOR_MODE );
    dv.setUint8( 4, message.sensorMode );
    dv.setUint32( 5, message.encoderCpr, true );
    return dv;
};

export const serializeWriteSensorModeResponse = ( message: IWriteSensorModeResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_SENSOR_MODE );
    dv.setUint8( 4, message.sensorMode );
    dv.setUint32( 5, message.encoderCpr, true );
    return dv;
};

export const serializeReadSensorModeRequest = ( message: IReadSensorModeRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_SENSOR_MODE );
    return dv;
};

export const serializeReadSensorModeResponse = ( message: IReadSensorModeResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_SENSOR_MODE );
    dv.setUint8( 4, message.sensorMode );
    dv.setUint32( 5, message.encoderCpr, true );
    dv.setFloat32( 9, message.encoderOffset, true );
    dv.setInt8( 13, message.encoderDirection );
    dv.setFloat32( 14, message.hallsensorForwardOffset, true );
    dv.setFloat32( 18, message.hallsensorReverseOffset, true );
    dv.setInt8( 22, message.hallsensorDirection );
    return dv;
};

export const serializeStartEncoderCalRequest = ( message: IStartEncoderCalRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.START_ENCODER_CAL );
    return dv;
};

export const serializeStartEncoderCalResponse = ( message: IStartEncoderCalResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.START_ENCODER_CAL );
    return dv;
};

export const serializeGetEncoderCalResultRequest = ( message: IGetEncoderCalResultRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.GET_ENCODER_CAL_RESULT );
    return dv;
};

export const serializeGetEncoderCalResultResponse = ( message: IGetEncoderCalResultResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.GET_ENCODER_CAL_RESULT );
    dv.setFloat32( 4, message.offset, true );
    dv.setUint8( 8, message.status );
    dv.setInt8( 9, message.direction );
    return dv;
};

export const serializeEncoderCalResultRequest = ( message: IEncoderCalResultRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ENCODER_CAL_RESULT );
    return dv;
};

export const serializeEncoderCalResultResponse = ( message: IEncoderCalResultResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ENCODER_CAL_RESULT );
    dv.setFloat32( 4, message.offset, true );
    dv.setUint8( 8, message.status );
    dv.setInt8( 9, message.direction );
    return dv;
};

export const serializeWriteOpenLoopConfigRequest = ( message: IWriteOpenLoopConfigRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_OPEN_LOOP_CONFIG );
    dv.setFloat32( 4, message.accelerationRamp, true );
    return dv;
};

export const serializeWriteOpenLoopConfigResponse = ( message: IWriteOpenLoopConfigResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_OPEN_LOOP_CONFIG );
    dv.setFloat32( 4, message.accelerationRamp, true );
    return dv;
};

export const serializeReadControlModeRequest = ( message: IReadControlModeRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_CONTROL_MODE );
    return dv;
};

export const serializeReadControlModeResponse = ( message: IReadControlModeResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_CONTROL_MODE );
    dv.setUint8( 4, message.controlMode );
    return dv;
};

export const serializeWriteCanIdRequest = ( message: IWriteCanIdRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_CAN_ID );
    dv.setUint32( 4, message.canId, true );
    return dv;
};

export const serializeWriteCanIdResponse = ( message: IWriteCanIdResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_CAN_ID );
    dv.setUint32( 4, message.canId, true );
    return dv;
};

export const serializeReadCanIdRequest = ( message: IReadCanIdRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_CAN_ID );
    return dv;
};

export const serializeReadCanIdResponse = ( message: IReadCanIdResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_CAN_ID );
    dv.setUint32( 4, message.canId, true );
    return dv;
};

export const serializeWriteEscIdRequest = ( message: IWriteEscIdRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_ESC_ID );
    dv.setUint32( 4, message.escIndex, true );
    return dv;
};

export const serializeWriteEscIdResponse = ( message: IWriteEscIdResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_ESC_ID );
    dv.setUint32( 4, message.escIndex, true );
    return dv;
};

export const serializeReadEscIdRequest = ( message: IReadEscIdRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_ESC_ID );
    return dv;
};

export const serializeReadEscIdResponse = ( message: IReadEscIdResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_ESC_ID );
    dv.setUint32( 4, message.escIndex, true );
    return dv;
};

export const serializeGetBuildInfoRequest = ( message: IGetBuildInfoRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.GET_BUILD_INFO );
    return dv;
};

export const serializeGetBuildInfoResponse = ( message: IGetBuildInfoResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.GET_BUILD_INFO );
    dv.setUint32( 4, message.year, true );
    dv.setUint32( 8, message.month, true );
    dv.setUint32( 12, message.day, true );
    dv.setUint32( 16, message.increment, true );
    dv.setUint8( 20, message.buildType );
    dv.setUint32( 21, message.dirty, true );
    return dv;
};

export const serializeReadMtpaStatusRequest = ( message: IReadMtpaStatusRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_MTPA_STATUS );
    return dv;
};

export const serializeReadMtpaStatusResponse = ( message: IReadMtpaStatusResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_MTPA_STATUS );
    dv.setInt8( 4, message.mtpa );
    return dv;
};

export const serializeReadFluxWeakeningStatusRequest = ( message: IReadFluxWeakeningStatusRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_FLUX_WEAKENING_STATUS );
    return dv;
};

export const serializeReadFluxWeakeningStatusResponse = ( message: IReadFluxWeakeningStatusResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_FLUX_WEAKENING_STATUS );
    dv.setInt8( 4, message.fluxWeakening );
    return dv;
};

export const serializeWritePositionControlSettingsRequest = ( message: IWritePositionControlSettingsRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_POSITION_CONTROL_SETTINGS );
    dv.setFloat32( 4, message.positionControlProportionalGain, true );
    dv.setFloat32( 8, message.positionControlIntegralGain, true );
    dv.setFloat32( 12, message.positionControlDerivGain, true );
    dv.setFloat32( 16, message.positionControlMaxSpeed, true );
    dv.setFloat32( 20, message.positionControlMaxAccel, true );
    dv.setFloat32( 24, message.positionControlDeadband, true );
    dv.setInt8( 28, message.positionControlType );
    dv.setInt8( 29, message.positionUnits );
    dv.setInt8( 30, message.positionResolution );
    dv.setFloat32( 31, message.travelDistance, true );
    return dv;
};

export const serializeWritePositionControlSettingsResponse = ( message: IWritePositionControlSettingsResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.WRITE_POSITION_CONTROL_SETTINGS );
    dv.setFloat32( 4, message.positionControlProportionalGain, true );
    dv.setFloat32( 8, message.positionControlIntegralGain, true );
    dv.setFloat32( 12, message.positionControlDerivGain, true );
    dv.setFloat32( 16, message.positionControlMaxSpeed, true );
    dv.setFloat32( 20, message.positionControlMaxAccel, true );
    dv.setFloat32( 24, message.positionControlDeadband, true );
    dv.setInt8( 28, message.positionControlType );
    dv.setInt8( 29, message.positionUnits );
    dv.setInt8( 30, message.positionResolution );
    dv.setFloat32( 31, message.travelDistance, true );
    return dv;
};

export const serializeReadPositionControlSettingsRequest = ( message: IReadPositionControlSettingsRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_POSITION_CONTROL_SETTINGS );
    return dv;
};

export const serializeReadPositionControlSettingsResponse = ( message: IReadPositionControlSettingsResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_POSITION_CONTROL_SETTINGS );
    dv.setFloat32( 4, message.positionControlProportionalGain, true );
    dv.setFloat32( 8, message.positionControlIntegralGain, true );
    dv.setFloat32( 12, message.positionControlDerivGain, true );
    dv.setFloat32( 16, message.positionControlMaxSpeed, true );
    dv.setFloat32( 20, message.positionControlMaxAccel, true );
    dv.setFloat32( 24, message.positionControlDeadband, true );
    dv.setInt8( 28, message.positionControlType );
    dv.setInt8( 29, message.positionUnits );
    dv.setInt8( 30, message.positionResolution );
    dv.setFloat32( 31, message.travelDistance, true );
    return dv;
};

export const serializeSetPositionSensorLimitsRequest = ( message: ISetPositionSensorLimitsRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.SET_POSITION_SENSOR_LIMITS );
    dv.setUint8( 4, message.setCurrentPosToMin );
    dv.setUint8( 5, message.setCurrentPosToMax );
    return dv;
};

export const serializeSetPositionSensorLimitsResponse = ( message: ISetPositionSensorLimitsResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.SET_POSITION_SENSOR_LIMITS );
    dv.setFloat32( 4, message.minPosition, true );
    dv.setFloat32( 8, message.maxPosition, true );
    return dv;
};

export const serializeReadPositionSensorLimitsRequest = ( message: IReadPositionSensorLimitsRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_POSITION_SENSOR_LIMITS );
    return dv;
};

export const serializeReadPositionSensorLimitsResponse = ( message: IReadPositionSensorLimitsResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_POSITION_SENSOR_LIMITS );
    dv.setFloat32( 4, message.minValue, true );
    dv.setFloat32( 8, message.maxValue, true );
    return dv;
};

export const serializeStartHallSensorCalRequest = ( message: IStartHallSensorCalRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.START_HALL_SENSOR_CAL );
    return dv;
};

export const serializeStartHallSensorCalResponse = ( message: IStartHallSensorCalResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.START_HALL_SENSOR_CAL );
    return dv;
};

export const serializeGetHallSensorCalResultRequest = ( message: IGetHallSensorCalResultRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.GET_HALL_SENSOR_CAL_RESULT );
    return dv;
};

export const serializeGetHallSensorCalResultResponse = ( message: IGetHallSensorCalResultResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.GET_HALL_SENSOR_CAL_RESULT );
    dv.setFloat32( 4, message.forwardOffset, true );
    dv.setFloat32( 8, message.reverseOffset, true );
    dv.setUint8( 12, message.status );
    dv.setInt8( 13, message.direction );
    return dv;
};

export const serializeHallSensorCalResultRequest = ( message: IHallSensorCalResultRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.HALL_SENSOR_CAL_RESULT );
    return dv;
};

export const serializeHallSensorCalResultResponse = ( message: IHallSensorCalResultResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.HALL_SENSOR_CAL_RESULT );
    dv.setFloat32( 4, message.forwardOffset, true );
    dv.setFloat32( 8, message.reverseOffset, true );
    dv.setUint8( 12, message.status );
    dv.setInt8( 13, message.direction );
    return dv;
};

export const serializeClearAllFaultsRequest = ( message: IClearAllFaultsRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.CLEAR_ALL_FAULTS );
    return dv;
};

export const serializeClearAllFaultsResponse = ( message: IClearAllFaultsResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.CLEAR_ALL_FAULTS );
    return dv;
};

export const serializeCertExchange1Request = ( message: ICertExchange1Request ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.CERT_EXCHANGE_1 );
    for ( let i = 0; i < 50; i++ ) dv.setUint8( 4 + i, message.sLabCertFirstHalf[ i ] );
    return dv;
};

export const serializeCertExchange1Response = ( message: ICertExchange1Response ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.CERT_EXCHANGE_1 );
    for ( let i = 0; i < 50; i++ ) dv.setUint8( 4 + i, message.mcuCertFirstHalf[ i ] );
    return dv;
};

export const serializeCertExchange2Request = ( message: ICertExchange2Request ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.CERT_EXCHANGE_2 );
    for ( let i = 0; i < 50; i++ ) dv.setUint8( 4 + i, message.sLabCertLastHalf[ i ] );
    return dv;
};

export const serializeCertExchange2Response = ( message: ICertExchange2Response ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.CERT_EXCHANGE_2 );
    dv.setInt8( 4, message.result );
    for ( let i = 0; i < 50; i++ ) dv.setUint8( 5 + i, message.mcuCertLastHalf[ i ] );
    return dv;
};

export const serializeEncChallenge1Request = ( message: IEncChallenge1Request ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ENC_CHALLENGE_1 );
    for ( let i = 0; i < 16; i++ ) dv.setUint8( 4 + i, message.challengeA[ i ] );
    return dv;
};

export const serializeEncChallenge1Response = ( message: IEncChallenge1Response ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ENC_CHALLENGE_1 );
    for ( let i = 0; i < 16; i++ ) dv.setUint8( 4 + i, message.encChallengeA[ i ] );
    for ( let i = 0; i < 16; i++ ) dv.setUint8( 20 + i, message.challengeB[ i ] );
    return dv;
};

export const serializeEncChallenge2Request = ( message: IEncChallenge2Request ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ENC_CHALLENGE_2 );
    for ( let i = 0; i < 16; i++ ) dv.setUint8( 4 + i, message.encChallengeB[ i ] );
    return dv;
};

export const serializeEncChallenge2Response = ( message: IEncChallenge2Response ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ENC_CHALLENGE_2 );
    dv.setInt8( 4, message.result );
    return dv;
};

export const serializeKeepAliveRequest = ( message: IKeepAliveRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.KEEP_ALIVE );
    return dv;
};

export const serializeKeepAliveResponse = ( message: IKeepAliveResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.KEEP_ALIVE );
    dv.setInt8( 4, message.authStatus );
    return dv;
};

export const serializeKeyConfigRequest = ( message: IKeyConfigRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.KEY_CONFIG );
    for ( let i = 0; i < 60; i++ ) dv.setUint8( 4 + i, message.keyBytestream[ i ] );
    return dv;
};

export const serializeKeyConfigResponse = ( message: IKeyConfigResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.KEY_CONFIG );
    for ( let i = 0; i < 60; i++ ) dv.setUint8( 4 + i, message.keyBytestreamRsp[ i ] );
    return dv;
};

export const serializeStartHomingCalRequest = ( message: IStartHomingCalRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.START_HOMING_CAL );
    return dv;
};

export const serializeStartHomingCalResponse = ( message: IStartHomingCalResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.START_HOMING_CAL );
    return dv;
};

export const serializeHomingCalResultRequest = ( message: IHomingCalResultRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.HOMING_CAL_RESULT );
    return dv;
};

export const serializeHomingCalResultResponse = ( message: IHomingCalResultResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.HOMING_CAL_RESULT );
    dv.setFloat32( 4, message.zeroOffset, true );
    dv.setUint8( 8, message.status );
    return dv;
};

export const serializeStartSysidRequest = ( message: IStartSysidRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.START_SYSID );
    return dv;
};

export const serializeStartSysidResponse = ( message: IStartSysidResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.START_SYSID );
    return dv;
};

export const serializeStopSysidRequest = ( message: IStopSysidRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.STOP_SYSID );
    return dv;
};

export const serializeStopSysidResponse = ( message: IStopSysidResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.STOP_SYSID );
    return dv;
};

export const serializeZeroDareSensorRequest = ( message: IZeroDareSensorRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ZERO_DARE_SENSOR );
    return dv;
};

export const serializeZeroDareSensorResponse = ( message: IZeroDareSensorResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ZERO_DARE_SENSOR );
    dv.setUint16( 4, message.encoder0ZeroPos, true );
    dv.setUint16( 6, message.encoder1ZeroPos, true );
    return dv;
};

export const serializeReadTotalActuatorsRequest = ( message: IReadTotalActuatorsRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_TOTAL_ACTUATORS );
    return dv;
};

export const serializeReadTotalActuatorsResponse = ( message: IReadTotalActuatorsResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.READ_TOTAL_ACTUATORS );
    dv.setUint8( 4, message.detectedNodes );
    dv.setUint8( 5, message.expectedNodes );
    dv.setUint32( 6, message.operationalNodesBitmap, true );
    return dv;
};

export const serializeActuatorInfoRequest = ( message: IActuatorInfoRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ACTUATOR_INFO );
    return dv;
};

export const serializeActuatorInfoResponse = ( message: IActuatorInfoResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.ACTUATOR_INFO );
    dv.setUint8( 4, message.nodeId );
    for ( let i = 0; i < 27; i++ ) dv.setUint8( 5 + i, message.dispositionStr[ i ] );
    return dv;
};

export const serializeSetControlModeRequest = ( message: ISetControlModeRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.SET_CONTROL_MODE );
    dv.setUint8( 4, message.controlMode );
    return dv;
};

export const serializeSetControlModeResponse = ( message: ISetControlModeResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.SET_CONTROL_MODE );
    dv.setUint8( 4, message.controlMode );
    return dv;
};

export const serializeSetUsbThrottleControlRequest = ( message: ISetUsbThrottleControlRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.SET_USB_THROTTLE_CONTROL );
    dv.setUint32( 4, message.value, true );
    return dv;
};

export const serializeSetUsbThrottleControlResponse = ( message: ISetUsbThrottleControlResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.SET_USB_THROTTLE_CONTROL );
    dv.setUint32( 4, message.value, true );
    return dv;
};

export const serializeFaultDataMessage = ( message: IFaultDataMessage ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.FAULT_DATA );
    dv.setUint32( 4, message.code, true );
    return dv;
};

export const serializeRealtimeDataMessage = ( message: IRealtimeDataMessage ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.REALTIME_DATA );
    dv.setFloat32( 4, message.motorSpeed, true );
    dv.setFloat32( 8, message.motorCurrent, true );
    dv.setFloat32( 12, message.batteryVoltage, true );
    dv.setFloat32( 16, message.batteryCurrent, true );
    dv.setFloat32( 20, message.servoPulse, true );
    dv.setFloat32( 24, message.inverterTemp, true );
    dv.setUint8( 28, message.controllerState );
    dv.setUint8( 29, message.faultCodeDeprecated );
    dv.setUint32( 30, message.uptimeMs, true );
    dv.setFloat32( 34, message.motorPosition, true );
    dv.setFloat32( 38, message.positionSensorReading, true );
    dv.setUint32( 42, message.faultsBitmapLower32, true );
    dv.setUint16( 46, message.faultsBitmapUpper16, true );
    dv.setFloat32( 48, message.externalThermTemp, true );
    dv.setFloat32( 52, message.rawPositionSensor, true );
    dv.setFloat32( 56, message.sysidFrequency, true );
    dv.setFloat32( 60, message.sysidMagnitude, true );
    return dv;
};

export const serializeVariableTelemetryMessage = ( message: IVariableTelemetryMessage ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.VARIABLE_TELEMETRY );
    dv.setUint8( 4, message.telemId );
    for ( let i = 0; i < 59; i++ ) dv.setUint8( 5 + i, message.telemBytestream[ i ] );
    return dv;
};

export const serializeMultiMotorTelemetryMessage = ( message: IMultiMotorTelemetryMessage ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.MULTI_MOTOR_TELEMETRY );
    dv.setUint8( 4, message.actuatorNodeId );
    dv.setUint32( 5, message.faultsBitmapLower32, true );
    dv.setUint16( 9, message.faultsBitmapUpper16, true );
    dv.setInt32( 11, message.currentPosition, true );
    dv.setInt32( 15, message.velocityActualValue, true );
    dv.setInt16( 19, message.torqueActualValue, true );
    dv.setInt16( 21, message.currentActualValue, true );
    dv.setUint32( 23, message.targetPosition, true );
    dv.setUint16( 27, message.statusWord, true );
    dv.setFloat32( 29, message.mosfetTemperature, true );
    dv.setFloat32( 33, message.batteryCurrent, true );
    return dv;
};

export const serializeFirmwareUpdateRequest = ( message: IFirmwareUpdateRequest ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.FIRMWARE_UPDATE );
    return dv;
};

export const serializeFirmwareUpdateResponse = ( message: IFirmwareUpdateResponse ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.FIRMWARE_UPDATE );
    return dv;
};

export const serializeUserDefinedMessage = ( message: IUserDefinedMessage ): DataView => {
    const dv = new DataView( new ArrayBuffer( 64 ) );
    dv.setUint8( 0, PacketId.USER_DEFINED );
    return dv;
};
export const deserializeInvalidRequest = ( dv: DataView ): IInvalidRequest => {
    return {
    };
};

export const deserializeInvalidResponse = ( dv: DataView ): IInvalidResponse => {
    return {
    };
};

export const deserializeHandshakeRequest = ( dv: DataView ): IHandshakeRequest => {
    return {
    };
};

export const deserializeHandshakeResponse = ( dv: DataView ): IHandshakeResponse => {
    return {
        versionMajor: dv.getUint32( 4, true ),
        versionMinor: dv.getUint32( 8, true ),
        versionBuild: dv.getUint32( 12, true ),
        resistance: dv.getFloat32( 16, true ),
        ld: dv.getFloat32( 20, true ),
        lq: dv.getFloat32( 24, true ),
        fluxLinkage: dv.getFloat32( 28, true ),
        gitHash: dv.getUint32( 32, true ),
        deviceId1: dv.getUint32( 36, true ),
        deviceId2: dv.getUint32( 40, true ),
        deviceId3: dv.getUint32( 44, true ),
    };
};

export const deserializeStartParamDetectRequest = ( dv: DataView ): IStartParamDetectRequest => {
    return {
        paramDetectMaxCurrent: dv.getFloat32( 4, true ),
        paramDetectMaxRpm: dv.getFloat32( 8, true ),
    };
};

export const deserializeStartParamDetectResponse = ( dv: DataView ): IStartParamDetectResponse => {
    return {
        resistance: dv.getFloat32( 4, true ),
        ld: dv.getFloat32( 8, true ),
        lq: dv.getFloat32( 12, true ),
        fluxLinkage: dv.getFloat32( 16, true ),
    };
};

export const deserializeWriteInputConfigRequest = ( dv: DataView ): IWriteInputConfigRequest => {
    return {
        inputLimitUpper: dv.getUint32( 4, true ),
        inputLimitLower: dv.getUint32( 8, true ),
        inputLimitCenter: dv.getUint32( 12, true ),
        inputMode: dv.getUint8( 16 ),
        alwaysOn: dv.getUint8( 17 ),
    };
};

export const deserializeWriteInputConfigResponse = ( dv: DataView ): IWriteInputConfigResponse => {
    return {
        inputLimitUpper: dv.getUint32( 4, true ),
        inputLimitLower: dv.getUint32( 8, true ),
        inputLimitCenter: dv.getUint32( 12, true ),
        inputMode: dv.getUint8( 16 ),
        alwaysOn: dv.getUint8( 17 ),
    };
};

export const deserializeWritePowerConfigRequest = ( dv: DataView ): IWritePowerConfigRequest => {
    return {
        motorCurrentLimit: dv.getFloat32( 4, true ),
        batteryCurrentLimit: dv.getFloat32( 8, true ),
        criticalOvervoltageThreshold: dv.getFloat32( 12, true ),
        criticalUndervoltageThreshold: dv.getFloat32( 16, true ),
        overcurrentThresholdDeprecated: dv.getFloat32( 20, true ),
        overtemperatureThreshold: dv.getFloat32( 24, true ),
        warningOvervoltageThreshold: dv.getFloat32( 28, true ),
        warningUndervoltageThreshold: dv.getFloat32( 32, true ),
        warningMotorCurrentThreshold: dv.getFloat32( 36, true ),
        criticalMotorCurrentThreshold: dv.getFloat32( 40, true ),
    };
};

export const deserializeWritePowerConfigResponse = ( dv: DataView ): IWritePowerConfigResponse => {
    return {
        motorCurrentLimit: dv.getFloat32( 4, true ),
        batteryCurrentLimit: dv.getFloat32( 8, true ),
        criticalOvervoltageThreshold: dv.getFloat32( 12, true ),
        criticalUndervoltageThreshold: dv.getFloat32( 16, true ),
        overcurrentThresholdDeprecated: dv.getFloat32( 20, true ),
        overtemperatureThreshold: dv.getFloat32( 24, true ),
        warningOvervoltageThreshold: dv.getFloat32( 28, true ),
        warningUndervoltageThreshold: dv.getFloat32( 32, true ),
        warningMotorCurrentThreshold: dv.getFloat32( 36, true ),
        criticalMotorCurrentThreshold: dv.getFloat32( 40, true ),
    };
};

export const deserializeReadFaultRequest = ( dv: DataView ): IReadFaultRequest => {
    return {
    };
};

export const deserializeReadFaultResponse = ( dv: DataView ): IReadFaultResponse => {
    return {
    };
};

export const deserializeReadTelemetryRequest = ( dv: DataView ): IReadTelemetryRequest => {
    return {
    };
};

export const deserializeReadTelemetryResponse = ( dv: DataView ): IReadTelemetryResponse => {
    return {
    };
};

export const deserializeReadMotorParamRequest = ( dv: DataView ): IReadMotorParamRequest => {
    return {
    };
};

export const deserializeReadMotorParamResponse = ( dv: DataView ): IReadMotorParamResponse => {
    return {
    };
};

export const deserializeReadInputConfigRequest = ( dv: DataView ): IReadInputConfigRequest => {
    return {
    };
};

export const deserializeReadInputConfigResponse = ( dv: DataView ): IReadInputConfigResponse => {
    return {
        inputLimitUpper: dv.getUint32( 4, true ),
        inputLimitLower: dv.getUint32( 8, true ),
        inputLimitCenter: dv.getUint32( 12, true ),
        inputMode: dv.getUint8( 16 ),
        alwaysOn: dv.getUint8( 17 ),
    };
};

export const deserializeReadPowerConfigRequest = ( dv: DataView ): IReadPowerConfigRequest => {
    return {
    };
};

export const deserializeReadPowerConfigResponse = ( dv: DataView ): IReadPowerConfigResponse => {
    return {
        motorCurrentLimit: dv.getFloat32( 4, true ),
        batteryCurrentLimit: dv.getFloat32( 8, true ),
        criticalOvervoltageThreshold: dv.getFloat32( 12, true ),
        criticalUndervoltageThreshold: dv.getFloat32( 16, true ),
        overcurrentThresholdDeprecated: dv.getFloat32( 20, true ),
        overtemperatureThreshold: dv.getFloat32( 24, true ),
        warningOvervoltageThreshold: dv.getFloat32( 28, true ),
        warningUndervoltageThreshold: dv.getFloat32( 32, true ),
        warningMotorCurrentThreshold: dv.getFloat32( 36, true ),
        criticalMotorCurrentThreshold: dv.getFloat32( 40, true ),
    };
};

export const deserializeWriteParametersRequest = ( dv: DataView ): IWriteParametersRequest => {
    return {
        resistance: dv.getFloat32( 4, true ),
        ld: dv.getFloat32( 8, true ),
        lq: dv.getFloat32( 12, true ),
        fluxLinkage: dv.getFloat32( 16, true ),
    };
};

export const deserializeWriteParametersResponse = ( dv: DataView ): IWriteParametersResponse => {
    return {
        resistance: dv.getFloat32( 4, true ),
        ld: dv.getFloat32( 8, true ),
        lq: dv.getFloat32( 12, true ),
        fluxLinkage: dv.getFloat32( 16, true ),
    };
};

export const deserializeWriteControlConfigRequest = ( dv: DataView ): IWriteControlConfigRequest => {
    return {
        motorMaxSpeed: dv.getFloat32( 4, true ),
        polePairCount: dv.getFloat32( 8, true ),
        speedControlProportionalGain: dv.getFloat32( 12, true ),
        speedControlIntegralGain: dv.getFloat32( 16, true ),
        deprecatedPositionControlProportionalGain: dv.getFloat32( 20, true ),
        controlMode: dv.getUint8( 24 ),
        mtpa: dv.getInt8( 25 ),
        fluxWeakening: dv.getInt8( 26 ),
    };
};

export const deserializeWriteControlConfigResponse = ( dv: DataView ): IWriteControlConfigResponse => {
    return {
        motorMaxSpeed: dv.getFloat32( 4, true ),
        polePairCount: dv.getFloat32( 8, true ),
        speedControlProportionalGain: dv.getFloat32( 12, true ),
        speedControlIntegralGain: dv.getFloat32( 16, true ),
        deprecatedPositionControlProportionalGain: dv.getFloat32( 20, true ),
        controlMode: dv.getUint8( 24 ),
        mtpa: dv.getInt8( 25 ),
        fluxWeakening: dv.getInt8( 26 ),
    };
};

export const deserializeWriteSensorModeRequest = ( dv: DataView ): IWriteSensorModeRequest => {
    return {
        sensorMode: dv.getUint8( 4 ),
        encoderCpr: dv.getUint32( 5, true ),
    };
};

export const deserializeWriteSensorModeResponse = ( dv: DataView ): IWriteSensorModeResponse => {
    return {
        sensorMode: dv.getUint8( 4 ),
        encoderCpr: dv.getUint32( 5, true ),
    };
};

export const deserializeReadSensorModeRequest = ( dv: DataView ): IReadSensorModeRequest => {
    return {
    };
};

export const deserializeReadSensorModeResponse = ( dv: DataView ): IReadSensorModeResponse => {
    return {
        sensorMode: dv.getUint8( 4 ),
        encoderCpr: dv.getUint32( 5, true ),
        encoderOffset: dv.getFloat32( 9, true ),
        encoderDirection: dv.getInt8( 13 ),
        hallsensorForwardOffset: dv.getFloat32( 14, true ),
        hallsensorReverseOffset: dv.getFloat32( 18, true ),
        hallsensorDirection: dv.getInt8( 22 ),
    };
};

export const deserializeStartEncoderCalRequest = ( dv: DataView ): IStartEncoderCalRequest => {
    return {
    };
};

export const deserializeStartEncoderCalResponse = ( dv: DataView ): IStartEncoderCalResponse => {
    return {
    };
};

export const deserializeGetEncoderCalResultRequest = ( dv: DataView ): IGetEncoderCalResultRequest => {
    return {
    };
};

export const deserializeGetEncoderCalResultResponse = ( dv: DataView ): IGetEncoderCalResultResponse => {
    return {
        offset: dv.getFloat32( 4, true ),
        status: dv.getUint8( 8 ),
        direction: dv.getInt8( 9 ),
    };
};

export const deserializeEncoderCalResultRequest = ( dv: DataView ): IEncoderCalResultRequest => {
    return {
    };
};

export const deserializeEncoderCalResultResponse = ( dv: DataView ): IEncoderCalResultResponse => {
    return {
        offset: dv.getFloat32( 4, true ),
        status: dv.getUint8( 8 ),
        direction: dv.getInt8( 9 ),
    };
};

export const deserializeWriteOpenLoopConfigRequest = ( dv: DataView ): IWriteOpenLoopConfigRequest => {
    return {
        accelerationRamp: dv.getFloat32( 4, true ),
    };
};

export const deserializeWriteOpenLoopConfigResponse = ( dv: DataView ): IWriteOpenLoopConfigResponse => {
    return {
        accelerationRamp: dv.getFloat32( 4, true ),
    };
};

export const deserializeReadControlModeRequest = ( dv: DataView ): IReadControlModeRequest => {
    return {
    };
};

export const deserializeReadControlModeResponse = ( dv: DataView ): IReadControlModeResponse => {
    return {
        controlMode: dv.getUint8( 4 ),
    };
};

export const deserializeWriteCanIdRequest = ( dv: DataView ): IWriteCanIdRequest => {
    return {
        canId: dv.getUint32( 4, true ),
    };
};

export const deserializeWriteCanIdResponse = ( dv: DataView ): IWriteCanIdResponse => {
    return {
        canId: dv.getUint32( 4, true ),
    };
};

export const deserializeReadCanIdRequest = ( dv: DataView ): IReadCanIdRequest => {
    return {
    };
};

export const deserializeReadCanIdResponse = ( dv: DataView ): IReadCanIdResponse => {
    return {
        canId: dv.getUint32( 4, true ),
    };
};

export const deserializeWriteEscIdRequest = ( dv: DataView ): IWriteEscIdRequest => {
    return {
        escIndex: dv.getUint32( 4, true ),
    };
};

export const deserializeWriteEscIdResponse = ( dv: DataView ): IWriteEscIdResponse => {
    return {
        escIndex: dv.getUint32( 4, true ),
    };
};

export const deserializeReadEscIdRequest = ( dv: DataView ): IReadEscIdRequest => {
    return {
    };
};

export const deserializeReadEscIdResponse = ( dv: DataView ): IReadEscIdResponse => {
    return {
        escIndex: dv.getUint32( 4, true ),
    };
};

export const deserializeGetBuildInfoRequest = ( dv: DataView ): IGetBuildInfoRequest => {
    return {
    };
};

export const deserializeGetBuildInfoResponse = ( dv: DataView ): IGetBuildInfoResponse => {
    return {
        year: dv.getUint32( 4, true ),
        month: dv.getUint32( 8, true ),
        day: dv.getUint32( 12, true ),
        increment: dv.getUint32( 16, true ),
        buildType: dv.getUint8( 20 ),
        dirty: dv.getUint32( 21, true ),
    };
};

export const deserializeReadMtpaStatusRequest = ( dv: DataView ): IReadMtpaStatusRequest => {
    return {
    };
};

export const deserializeReadMtpaStatusResponse = ( dv: DataView ): IReadMtpaStatusResponse => {
    return {
        mtpa: dv.getInt8( 4 ),
    };
};

export const deserializeReadFluxWeakeningStatusRequest = ( dv: DataView ): IReadFluxWeakeningStatusRequest => {
    return {
    };
};

export const deserializeReadFluxWeakeningStatusResponse = ( dv: DataView ): IReadFluxWeakeningStatusResponse => {
    return {
        fluxWeakening: dv.getInt8( 4 ),
    };
};

export const deserializeWritePositionControlSettingsRequest = ( dv: DataView ): IWritePositionControlSettingsRequest => {
    return {
        positionControlProportionalGain: dv.getFloat32( 4, true ),
        positionControlIntegralGain: dv.getFloat32( 8, true ),
        positionControlDerivGain: dv.getFloat32( 12, true ),
        positionControlMaxSpeed: dv.getFloat32( 16, true ),
        positionControlMaxAccel: dv.getFloat32( 20, true ),
        positionControlDeadband: dv.getFloat32( 24, true ),
        positionControlType: dv.getInt8( 28 ),
        positionUnits: dv.getInt8( 29 ),
        positionResolution: dv.getInt8( 30 ),
        travelDistance: dv.getFloat32( 31, true ),
    };
};

export const deserializeWritePositionControlSettingsResponse = ( dv: DataView ): IWritePositionControlSettingsResponse => {
    return {
        positionControlProportionalGain: dv.getFloat32( 4, true ),
        positionControlIntegralGain: dv.getFloat32( 8, true ),
        positionControlDerivGain: dv.getFloat32( 12, true ),
        positionControlMaxSpeed: dv.getFloat32( 16, true ),
        positionControlMaxAccel: dv.getFloat32( 20, true ),
        positionControlDeadband: dv.getFloat32( 24, true ),
        positionControlType: dv.getInt8( 28 ),
        positionUnits: dv.getInt8( 29 ),
        positionResolution: dv.getInt8( 30 ),
        travelDistance: dv.getFloat32( 31, true ),
    };
};

export const deserializeReadPositionControlSettingsRequest = ( dv: DataView ): IReadPositionControlSettingsRequest => {
    return {
    };
};

export const deserializeReadPositionControlSettingsResponse = ( dv: DataView ): IReadPositionControlSettingsResponse => {
    return {
        positionControlProportionalGain: dv.getFloat32( 4, true ),
        positionControlIntegralGain: dv.getFloat32( 8, true ),
        positionControlDerivGain: dv.getFloat32( 12, true ),
        positionControlMaxSpeed: dv.getFloat32( 16, true ),
        positionControlMaxAccel: dv.getFloat32( 20, true ),
        positionControlDeadband: dv.getFloat32( 24, true ),
        positionControlType: dv.getInt8( 28 ),
        positionUnits: dv.getInt8( 29 ),
        positionResolution: dv.getInt8( 30 ),
        travelDistance: dv.getFloat32( 31, true ),
    };
};

export const deserializeSetPositionSensorLimitsRequest = ( dv: DataView ): ISetPositionSensorLimitsRequest => {
    return {
        setCurrentPosToMin: dv.getUint8( 4 ),
        setCurrentPosToMax: dv.getUint8( 5 ),
    };
};

export const deserializeSetPositionSensorLimitsResponse = ( dv: DataView ): ISetPositionSensorLimitsResponse => {
    return {
        minPosition: dv.getFloat32( 4, true ),
        maxPosition: dv.getFloat32( 8, true ),
    };
};

export const deserializeReadPositionSensorLimitsRequest = ( dv: DataView ): IReadPositionSensorLimitsRequest => {
    return {
    };
};

export const deserializeReadPositionSensorLimitsResponse = ( dv: DataView ): IReadPositionSensorLimitsResponse => {
    return {
        minValue: dv.getFloat32( 4, true ),
        maxValue: dv.getFloat32( 8, true ),
    };
};

export const deserializeStartHallSensorCalRequest = ( dv: DataView ): IStartHallSensorCalRequest => {
    return {
    };
};

export const deserializeStartHallSensorCalResponse = ( dv: DataView ): IStartHallSensorCalResponse => {
    return {
    };
};

export const deserializeGetHallSensorCalResultRequest = ( dv: DataView ): IGetHallSensorCalResultRequest => {
    return {
    };
};

export const deserializeGetHallSensorCalResultResponse = ( dv: DataView ): IGetHallSensorCalResultResponse => {
    return {
        forwardOffset: dv.getFloat32( 4, true ),
        reverseOffset: dv.getFloat32( 8, true ),
        status: dv.getUint8( 12 ),
        direction: dv.getInt8( 13 ),
    };
};

export const deserializeHallSensorCalResultRequest = ( dv: DataView ): IHallSensorCalResultRequest => {
    return {
    };
};

export const deserializeHallSensorCalResultResponse = ( dv: DataView ): IHallSensorCalResultResponse => {
    return {
        forwardOffset: dv.getFloat32( 4, true ),
        reverseOffset: dv.getFloat32( 8, true ),
        status: dv.getUint8( 12 ),
        direction: dv.getInt8( 13 ),
    };
};

export const deserializeClearAllFaultsRequest = ( dv: DataView ): IClearAllFaultsRequest => {
    return {
    };
};

export const deserializeClearAllFaultsResponse = ( dv: DataView ): IClearAllFaultsResponse => {
    return {
    };
};

export const deserializeCertExchange1Request = ( dv: DataView ): ICertExchange1Request => {
    return {
        sLabCertFirstHalf: new Uint8Array( dv.buffer, 4, 50 ),
    };
};

export const deserializeCertExchange1Response = ( dv: DataView ): ICertExchange1Response => {
    return {
        mcuCertFirstHalf: new Uint8Array( dv.buffer, 4, 50 ),
    };
};

export const deserializeCertExchange2Request = ( dv: DataView ): ICertExchange2Request => {
    return {
        sLabCertLastHalf: new Uint8Array( dv.buffer, 4, 50 ),
    };
};

export const deserializeCertExchange2Response = ( dv: DataView ): ICertExchange2Response => {
    return {
        result: dv.getInt8( 4 ),
        mcuCertLastHalf: new Uint8Array( dv.buffer, 5, 50 ),
    };
};

export const deserializeEncChallenge1Request = ( dv: DataView ): IEncChallenge1Request => {
    return {
        challengeA: new Uint8Array( dv.buffer, 4, 16 ),
    };
};

export const deserializeEncChallenge1Response = ( dv: DataView ): IEncChallenge1Response => {
    return {
        encChallengeA: new Uint8Array( dv.buffer, 4, 16 ),
        challengeB: new Uint8Array( dv.buffer, 20, 16 ),
    };
};

export const deserializeEncChallenge2Request = ( dv: DataView ): IEncChallenge2Request => {
    return {
        encChallengeB: new Uint8Array( dv.buffer, 4, 16 ),
    };
};

export const deserializeEncChallenge2Response = ( dv: DataView ): IEncChallenge2Response => {
    return {
        result: dv.getInt8( 4 ),
    };
};

export const deserializeKeepAliveRequest = ( dv: DataView ): IKeepAliveRequest => {
    return {
    };
};

export const deserializeKeepAliveResponse = ( dv: DataView ): IKeepAliveResponse => {
    return {
        authStatus: dv.getInt8( 4 ),
    };
};

export const deserializeKeyConfigRequest = ( dv: DataView ): IKeyConfigRequest => {
    return {
        keyBytestream: new Uint8Array( dv.buffer, 4, 60 ),
    };
};

export const deserializeKeyConfigResponse = ( dv: DataView ): IKeyConfigResponse => {
    return {
        keyBytestreamRsp: new Uint8Array( dv.buffer, 4, 60 ),
    };
};

export const deserializeStartHomingCalRequest = ( dv: DataView ): IStartHomingCalRequest => {
    return {
    };
};

export const deserializeStartHomingCalResponse = ( dv: DataView ): IStartHomingCalResponse => {
    return {
    };
};

export const deserializeHomingCalResultRequest = ( dv: DataView ): IHomingCalResultRequest => {
    return {
    };
};

export const deserializeHomingCalResultResponse = ( dv: DataView ): IHomingCalResultResponse => {
    return {
        zeroOffset: dv.getFloat32( 4, true ),
        status: dv.getUint8( 8 ),
    };
};

export const deserializeStartSysidRequest = ( dv: DataView ): IStartSysidRequest => {
    return {
    };
};

export const deserializeStartSysidResponse = ( dv: DataView ): IStartSysidResponse => {
    return {
    };
};

export const deserializeStopSysidRequest = ( dv: DataView ): IStopSysidRequest => {
    return {
    };
};

export const deserializeStopSysidResponse = ( dv: DataView ): IStopSysidResponse => {
    return {
    };
};

export const deserializeZeroDareSensorRequest = ( dv: DataView ): IZeroDareSensorRequest => {
    return {
    };
};

export const deserializeZeroDareSensorResponse = ( dv: DataView ): IZeroDareSensorResponse => {
    return {
        encoder0ZeroPos: dv.getUint16( 4, true ),
        encoder1ZeroPos: dv.getUint16( 6, true ),
    };
};

export const deserializeReadTotalActuatorsRequest = ( dv: DataView ): IReadTotalActuatorsRequest => {
    return {
    };
};

export const deserializeReadTotalActuatorsResponse = ( dv: DataView ): IReadTotalActuatorsResponse => {
    return {
        detectedNodes: dv.getUint8( 4 ),
        expectedNodes: dv.getUint8( 5 ),
        operationalNodesBitmap: dv.getUint32( 6, true ),
    };
};

export const deserializeActuatorInfoRequest = ( dv: DataView ): IActuatorInfoRequest => {
    return {
    };
};

export const deserializeActuatorInfoResponse = ( dv: DataView ): IActuatorInfoResponse => {
    return {
        nodeId: dv.getUint8( 4 ),
        dispositionStr: new Uint8Array( dv.buffer, 5, 27 ),
    };
};

export const deserializeSetControlModeRequest = ( dv: DataView ): ISetControlModeRequest => {
    return {
        controlMode: dv.getUint8( 4 ),
    };
};

export const deserializeSetControlModeResponse = ( dv: DataView ): ISetControlModeResponse => {
    return {
        controlMode: dv.getUint8( 4 ),
    };
};

export const deserializeSetUsbThrottleControlRequest = ( dv: DataView ): ISetUsbThrottleControlRequest => {
    return {
        value: dv.getUint32( 4, true ),
    };
};

export const deserializeSetUsbThrottleControlResponse = ( dv: DataView ): ISetUsbThrottleControlResponse => {
    return {
        value: dv.getUint32( 4, true ),
    };
};

export const deserializeFaultDataMessage = ( dv: DataView ): IFaultDataMessage => {
    return {
        code: dv.getUint32( 4, true ),
    };
};

export const deserializeRealtimeDataMessage = ( dv: DataView ): IRealtimeDataMessage => {
    return {
        motorSpeed: dv.getFloat32( 4, true ),
        motorCurrent: dv.getFloat32( 8, true ),
        batteryVoltage: dv.getFloat32( 12, true ),
        batteryCurrent: dv.getFloat32( 16, true ),
        servoPulse: dv.getFloat32( 20, true ),
        inverterTemp: dv.getFloat32( 24, true ),
        controllerState: dv.getUint8( 28 ),
        faultCodeDeprecated: dv.getUint8( 29 ),
        uptimeMs: dv.getUint32( 30, true ),
        motorPosition: dv.getFloat32( 34, true ),
        positionSensorReading: dv.getFloat32( 38, true ),
        faultsBitmapLower32: dv.getUint32( 42, true ),
        faultsBitmapUpper16: dv.getUint16( 46, true ),
        externalThermTemp: dv.getFloat32( 48, true ),
        rawPositionSensor: dv.getFloat32( 52, true ),
        sysidFrequency: dv.getFloat32( 56, true ),
        sysidMagnitude: dv.getFloat32( 60, true ),
    };
};

export const deserializeVariableTelemetryMessage = ( dv: DataView ): IVariableTelemetryMessage => {
    return {
        telemId: dv.getUint8( 4 ),
        telemBytestream: new Uint8Array( dv.buffer, 5, 59 ),
    };
};

export const deserializeMultiMotorTelemetryMessage = ( dv: DataView ): IMultiMotorTelemetryMessage => {
    return {
        actuatorNodeId: dv.getUint8( 4 ),
        faultsBitmapLower32: dv.getUint32( 5, true ),
        faultsBitmapUpper16: dv.getUint16( 9, true ),
        currentPosition: dv.getInt32( 11, true ),
        velocityActualValue: dv.getInt32( 15, true ),
        torqueActualValue: dv.getInt16( 19, true ),
        currentActualValue: dv.getInt16( 21, true ),
        targetPosition: dv.getUint32( 23, true ),
        statusWord: dv.getUint16( 27, true ),
        mosfetTemperature: dv.getFloat32( 29, true ),
        batteryCurrent: dv.getFloat32( 33, true ),
    };
};

export const deserializeFirmwareUpdateRequest = ( dv: DataView ): IFirmwareUpdateRequest => {
    return {
    };
};

export const deserializeFirmwareUpdateResponse = ( dv: DataView ): IFirmwareUpdateResponse => {
    return {
    };
};

export const deserializeUserDefinedMessage = ( dv: DataView ): IUserDefinedMessage => {
    return {
    };
};

export interface IReceivedPacketTypes {
    [ PacketId.INVALID ]: IInvalidResponse;
    [ PacketId.HANDSHAKE ]: IHandshakeResponse;
    [ PacketId.START_PARAM_DETECT ]: IStartParamDetectResponse;
    [ PacketId.WRITE_INPUT_CONFIG ]: IWriteInputConfigResponse;
    [ PacketId.WRITE_POWER_CONFIG ]: IWritePowerConfigResponse;
    [ PacketId.READ_FAULT ]: IReadFaultResponse;
    [ PacketId.READ_TELEMETRY ]: IReadTelemetryResponse;
    [ PacketId.READ_MOTOR_PARAM ]: IReadMotorParamResponse;
    [ PacketId.READ_INPUT_CONFIG ]: IReadInputConfigResponse;
    [ PacketId.READ_POWER_CONFIG ]: IReadPowerConfigResponse;
    [ PacketId.WRITE_PARAMETERS ]: IWriteParametersResponse;
    [ PacketId.WRITE_CONTROL_CONFIG ]: IWriteControlConfigResponse;
    [ PacketId.WRITE_SENSOR_MODE ]: IWriteSensorModeResponse;
    [ PacketId.READ_SENSOR_MODE ]: IReadSensorModeResponse;
    [ PacketId.START_ENCODER_CAL ]: IStartEncoderCalResponse;
    [ PacketId.GET_ENCODER_CAL_RESULT ]: IGetEncoderCalResultResponse;
    [ PacketId.ENCODER_CAL_RESULT ]: IEncoderCalResultResponse;
    [ PacketId.WRITE_OPEN_LOOP_CONFIG ]: IWriteOpenLoopConfigResponse;
    [ PacketId.READ_CONTROL_MODE ]: IReadControlModeResponse;
    [ PacketId.WRITE_CAN_ID ]: IWriteCanIdResponse;
    [ PacketId.READ_CAN_ID ]: IReadCanIdResponse;
    [ PacketId.WRITE_ESC_ID ]: IWriteEscIdResponse;
    [ PacketId.READ_ESC_ID ]: IReadEscIdResponse;
    [ PacketId.GET_BUILD_INFO ]: IGetBuildInfoResponse;
    [ PacketId.READ_MTPA_STATUS ]: IReadMtpaStatusResponse;
    [ PacketId.READ_FLUX_WEAKENING_STATUS ]: IReadFluxWeakeningStatusResponse;
    [ PacketId.WRITE_POSITION_CONTROL_SETTINGS ]: IWritePositionControlSettingsResponse;
    [ PacketId.READ_POSITION_CONTROL_SETTINGS ]: IReadPositionControlSettingsResponse;
    [ PacketId.SET_POSITION_SENSOR_LIMITS ]: ISetPositionSensorLimitsResponse;
    [ PacketId.READ_POSITION_SENSOR_LIMITS ]: IReadPositionSensorLimitsResponse;
    [ PacketId.START_HALL_SENSOR_CAL ]: IStartHallSensorCalResponse;
    [ PacketId.GET_HALL_SENSOR_CAL_RESULT ]: IGetHallSensorCalResultResponse;
    [ PacketId.HALL_SENSOR_CAL_RESULT ]: IHallSensorCalResultResponse;
    [ PacketId.CLEAR_ALL_FAULTS ]: IClearAllFaultsResponse;
    [ PacketId.CERT_EXCHANGE_1 ]: ICertExchange1Response;
    [ PacketId.CERT_EXCHANGE_2 ]: ICertExchange2Response;
    [ PacketId.ENC_CHALLENGE_1 ]: IEncChallenge1Response;
    [ PacketId.ENC_CHALLENGE_2 ]: IEncChallenge2Response;
    [ PacketId.KEEP_ALIVE ]: IKeepAliveResponse;
    [ PacketId.KEY_CONFIG ]: IKeyConfigResponse;
    [ PacketId.START_HOMING_CAL ]: IStartHomingCalResponse;
    [ PacketId.HOMING_CAL_RESULT ]: IHomingCalResultResponse;
    [ PacketId.START_SYSID ]: IStartSysidResponse;
    [ PacketId.STOP_SYSID ]: IStopSysidResponse;
    [ PacketId.ZERO_DARE_SENSOR ]: IZeroDareSensorResponse;
    [ PacketId.READ_TOTAL_ACTUATORS ]: IReadTotalActuatorsResponse;
    [ PacketId.ACTUATOR_INFO ]: IActuatorInfoResponse;
    [ PacketId.SET_CONTROL_MODE ]: ISetControlModeResponse;
    [ PacketId.SET_USB_THROTTLE_CONTROL ]: ISetUsbThrottleControlResponse;
    [ PacketId.FAULT_DATA ]: IFaultDataMessage;
    [ PacketId.REALTIME_DATA ]: IRealtimeDataMessage;
    [ PacketId.VARIABLE_TELEMETRY ]: IVariableTelemetryMessage;
    [ PacketId.MULTI_MOTOR_TELEMETRY ]: IMultiMotorTelemetryMessage;
    [ PacketId.FIRMWARE_UPDATE ]: IFirmwareUpdateResponse;
    [ PacketId.USER_DEFINED ]: IUserDefinedMessage;
}

export type PacketKeys<I extends PacketId> = keyof IReceivedPacketTypes[ I ];

type DisplayUnits = { [ I in PacketId ]: { [ K in PacketKeys<I> ]: string } };
export const displayUnits: DisplayUnits = {
    [ PacketId.INVALID ]: {
    },
    [ PacketId.HANDSHAKE ]: {
        versionMajor: "",
        versionMinor: "",
        versionBuild: "",
        resistance: "ohms",
        ld: "H",
        lq: "H",
        fluxLinkage: "Wb",
        gitHash: "",
        deviceId1: "",
        deviceId2: "",
        deviceId3: "",
    },
    [ PacketId.START_PARAM_DETECT ]: {
        resistance: "ohms",
        ld: "H",
        lq: "H",
        fluxLinkage: "Wb",
    },
    [ PacketId.WRITE_INPUT_CONFIG ]: {
        inputLimitUpper: "",
        inputLimitLower: "",
        inputLimitCenter: "",
        inputMode: "",
        alwaysOn: "",
    },
    [ PacketId.WRITE_POWER_CONFIG ]: {
        motorCurrentLimit: "A",
        batteryCurrentLimit: "A",
        criticalOvervoltageThreshold: "V",
        criticalUndervoltageThreshold: "V",
        overcurrentThresholdDeprecated: "A",
        overtemperatureThreshold: "°C",
        warningOvervoltageThreshold: "V",
        warningUndervoltageThreshold: "V",
        warningMotorCurrentThreshold: "A",
        criticalMotorCurrentThreshold: "A",
    },
    [ PacketId.READ_FAULT ]: {
    },
    [ PacketId.READ_TELEMETRY ]: {
    },
    [ PacketId.READ_MOTOR_PARAM ]: {
    },
    [ PacketId.READ_INPUT_CONFIG ]: {
        inputLimitUpper: "",
        inputLimitLower: "",
        inputLimitCenter: "",
        inputMode: "",
        alwaysOn: "",
    },
    [ PacketId.READ_POWER_CONFIG ]: {
        motorCurrentLimit: "A",
        batteryCurrentLimit: "A",
        criticalOvervoltageThreshold: "V",
        criticalUndervoltageThreshold: "V",
        overcurrentThresholdDeprecated: "A",
        overtemperatureThreshold: "°C",
        warningOvervoltageThreshold: "V",
        warningUndervoltageThreshold: "V",
        warningMotorCurrentThreshold: "A",
        criticalMotorCurrentThreshold: "A",
    },
    [ PacketId.WRITE_PARAMETERS ]: {
        resistance: "ohms",
        ld: "H",
        lq: "H",
        fluxLinkage: "Wb",
    },
    [ PacketId.WRITE_CONTROL_CONFIG ]: {
        motorMaxSpeed: "rad/s",
        polePairCount: "",
        speedControlProportionalGain: "Nm/(mrad/s)",
        speedControlIntegralGain: "N-m/rad",
        deprecatedPositionControlProportionalGain: "",
        controlMode: "",
        mtpa: "",
        fluxWeakening: "",
    },
    [ PacketId.WRITE_SENSOR_MODE ]: {
        sensorMode: "",
        encoderCpr: "",
    },
    [ PacketId.READ_SENSOR_MODE ]: {
        sensorMode: "",
        encoderCpr: "",
        encoderOffset: "mrads",
        encoderDirection: "",
        hallsensorForwardOffset: "",
        hallsensorReverseOffset: "",
        hallsensorDirection: "",
    },
    [ PacketId.START_ENCODER_CAL ]: {
    },
    [ PacketId.GET_ENCODER_CAL_RESULT ]: {
        offset: "radians",
        status: "",
        direction: "",
    },
    [ PacketId.ENCODER_CAL_RESULT ]: {
        offset: "mrads",
        status: "",
        direction: "",
    },
    [ PacketId.WRITE_OPEN_LOOP_CONFIG ]: {
        accelerationRamp: "erad/s^2",
    },
    [ PacketId.READ_CONTROL_MODE ]: {
        controlMode: "",
    },
    [ PacketId.WRITE_CAN_ID ]: {
        canId: "",
    },
    [ PacketId.READ_CAN_ID ]: {
        canId: "",
    },
    [ PacketId.WRITE_ESC_ID ]: {
        escIndex: "",
    },
    [ PacketId.READ_ESC_ID ]: {
        escIndex: "",
    },
    [ PacketId.GET_BUILD_INFO ]: {
        year: "",
        month: "",
        day: "",
        increment: "",
        buildType: "",
        dirty: "",
    },
    [ PacketId.READ_MTPA_STATUS ]: {
        mtpa: "",
    },
    [ PacketId.READ_FLUX_WEAKENING_STATUS ]: {
        fluxWeakening: "",
    },
    [ PacketId.WRITE_POSITION_CONTROL_SETTINGS ]: {
        positionControlProportionalGain: "",
        positionControlIntegralGain: "",
        positionControlDerivGain: "",
        positionControlMaxSpeed: "",
        positionControlMaxAccel: "",
        positionControlDeadband: "",
        positionControlType: "",
        positionUnits: "",
        positionResolution: "",
        travelDistance: "",
    },
    [ PacketId.READ_POSITION_CONTROL_SETTINGS ]: {
        positionControlProportionalGain: "",
        positionControlIntegralGain: "",
        positionControlDerivGain: "",
        positionControlMaxSpeed: "",
        positionControlMaxAccel: "",
        positionControlDeadband: "",
        positionControlType: "",
        positionUnits: "",
        positionResolution: "",
        travelDistance: "",
    },
    [ PacketId.SET_POSITION_SENSOR_LIMITS ]: {
        minPosition: "rad",
        maxPosition: "rad",
    },
    [ PacketId.READ_POSITION_SENSOR_LIMITS ]: {
        minValue: "",
        maxValue: "",
    },
    [ PacketId.START_HALL_SENSOR_CAL ]: {
    },
    [ PacketId.GET_HALL_SENSOR_CAL_RESULT ]: {
        forwardOffset: "radians",
        reverseOffset: "radians",
        status: "",
        direction: "",
    },
    [ PacketId.HALL_SENSOR_CAL_RESULT ]: {
        forwardOffset: "radians",
        reverseOffset: "radians",
        status: "",
        direction: "",
    },
    [ PacketId.CLEAR_ALL_FAULTS ]: {
    },
    [ PacketId.CERT_EXCHANGE_1 ]: {
        mcuCertFirstHalf: "",
    },
    [ PacketId.CERT_EXCHANGE_2 ]: {
        result: "",
        mcuCertLastHalf: "",
    },
    [ PacketId.ENC_CHALLENGE_1 ]: {
        encChallengeA: "",
        challengeB: "",
    },
    [ PacketId.ENC_CHALLENGE_2 ]: {
        result: "",
    },
    [ PacketId.KEEP_ALIVE ]: {
        authStatus: "",
    },
    [ PacketId.KEY_CONFIG ]: {
        keyBytestreamRsp: "",
    },
    [ PacketId.START_HOMING_CAL ]: {
    },
    [ PacketId.HOMING_CAL_RESULT ]: {
        zeroOffset: "radians",
        status: "",
    },
    [ PacketId.START_SYSID ]: {
    },
    [ PacketId.STOP_SYSID ]: {
    },
    [ PacketId.ZERO_DARE_SENSOR ]: {
        encoder0ZeroPos: "",
        encoder1ZeroPos: "",
    },
    [ PacketId.READ_TOTAL_ACTUATORS ]: {
        detectedNodes: "",
        expectedNodes: "",
        operationalNodesBitmap: "",
    },
    [ PacketId.ACTUATOR_INFO ]: {
        nodeId: "",
        dispositionStr: "",
    },
    [ PacketId.SET_CONTROL_MODE ]: {
        controlMode: "",
    },
    [ PacketId.SET_USB_THROTTLE_CONTROL ]: {
        value: "",
    },
    [ PacketId.FAULT_DATA ]: {
        code: "",
    },
    [ PacketId.REALTIME_DATA ]: {
        motorSpeed: "RPM",
        motorCurrent: "A",
        batteryVoltage: "V",
        batteryCurrent: "A",
        servoPulse: "",
        inverterTemp: "°C",
        controllerState: "",
        faultCodeDeprecated: "",
        uptimeMs: "ms",
        motorPosition: "radians",
        positionSensorReading: "",
        faultsBitmapLower32: "",
        faultsBitmapUpper16: "",
        externalThermTemp: "°C",
        rawPositionSensor: "",
        sysidFrequency: "Hz",
        sysidMagnitude: "",
    },
    [ PacketId.VARIABLE_TELEMETRY ]: {
        telemId: "",
        telemBytestream: "",
    },
    [ PacketId.MULTI_MOTOR_TELEMETRY ]: {
        actuatorNodeId: "",
        faultsBitmapLower32: "",
        faultsBitmapUpper16: "",
        currentPosition: "",
        velocityActualValue: "RPM",
        torqueActualValue: "Nm",
        currentActualValue: "mA",
        targetPosition: "",
        statusWord: "",
        mosfetTemperature: "°C",
        batteryCurrent: "A",
    },
    [ PacketId.FIRMWARE_UPDATE ]: {
    },
    [ PacketId.USER_DEFINED ]: {
    },
};

export const fullDisplayUnits: DisplayUnits = {
    [ PacketId.INVALID ]: {
    },
    [ PacketId.HANDSHAKE ]: {
        versionMajor: "",
        versionMinor: "",
        versionBuild: "",
        resistance: "ohms",
        ld: "henry",
        lq: "henry",
        fluxLinkage: "weber",
        gitHash: "",
        deviceId1: "",
        deviceId2: "",
        deviceId3: "",
    },
    [ PacketId.START_PARAM_DETECT ]: {
        resistance: "ohms",
        ld: "henry",
        lq: "henry",
        fluxLinkage: "weber",
    },
    [ PacketId.WRITE_INPUT_CONFIG ]: {
        inputLimitUpper: "",
        inputLimitLower: "",
        inputLimitCenter: "",
        inputMode: "",
        alwaysOn: "",
    },
    [ PacketId.WRITE_POWER_CONFIG ]: {
        motorCurrentLimit: "amps",
        batteryCurrentLimit: "amps",
        criticalOvervoltageThreshold: "volts",
        criticalUndervoltageThreshold: "volts",
        overcurrentThresholdDeprecated: "amps",
        overtemperatureThreshold: "celsius",
        warningOvervoltageThreshold: "volts",
        warningUndervoltageThreshold: "volts",
        warningMotorCurrentThreshold: "amps",
        criticalMotorCurrentThreshold: "amps",
    },
    [ PacketId.READ_FAULT ]: {
    },
    [ PacketId.READ_TELEMETRY ]: {
    },
    [ PacketId.READ_MOTOR_PARAM ]: {
    },
    [ PacketId.READ_INPUT_CONFIG ]: {
        inputLimitUpper: "",
        inputLimitLower: "",
        inputLimitCenter: "",
        inputMode: "",
        alwaysOn: "",
    },
    [ PacketId.READ_POWER_CONFIG ]: {
        motorCurrentLimit: "amps",
        batteryCurrentLimit: "amps",
        criticalOvervoltageThreshold: "volts",
        criticalUndervoltageThreshold: "volts",
        overcurrentThresholdDeprecated: "amps",
        overtemperatureThreshold: "celsius",
        warningOvervoltageThreshold: "volts",
        warningUndervoltageThreshold: "volts",
        warningMotorCurrentThreshold: "amps",
        criticalMotorCurrentThreshold: "amps",
    },
    [ PacketId.WRITE_PARAMETERS ]: {
        resistance: "ohms",
        ld: "henry",
        lq: "henry",
        fluxLinkage: "weber",
    },
    [ PacketId.WRITE_CONTROL_CONFIG ]: {
        motorMaxSpeed: "mechanical rad/s",
        polePairCount: "",
        speedControlProportionalGain: "Newton-meter-second per mechanical radian",
        speedControlIntegralGain: "Newton-meter per radian",
        deprecatedPositionControlProportionalGain: "",
        controlMode: "",
        mtpa: "",
        fluxWeakening: "",
    },
    [ PacketId.WRITE_SENSOR_MODE ]: {
        sensorMode: "",
        encoderCpr: "",
    },
    [ PacketId.READ_SENSOR_MODE ]: {
        sensorMode: "",
        encoderCpr: "",
        encoderOffset: "Mechanical radians",
        encoderDirection: "",
        hallsensorForwardOffset: "",
        hallsensorReverseOffset: "",
        hallsensorDirection: "",
    },
    [ PacketId.START_ENCODER_CAL ]: {
    },
    [ PacketId.GET_ENCODER_CAL_RESULT ]: {
        offset: "radians",
        status: "",
        direction: "",
    },
    [ PacketId.ENCODER_CAL_RESULT ]: {
        offset: "Mechanical radians",
        status: "",
        direction: "",
    },
    [ PacketId.WRITE_OPEN_LOOP_CONFIG ]: {
        accelerationRamp: "electrical radians per second squared",
    },
    [ PacketId.READ_CONTROL_MODE ]: {
        controlMode: "",
    },
    [ PacketId.WRITE_CAN_ID ]: {
        canId: "",
    },
    [ PacketId.READ_CAN_ID ]: {
        canId: "",
    },
    [ PacketId.WRITE_ESC_ID ]: {
        escIndex: "",
    },
    [ PacketId.READ_ESC_ID ]: {
        escIndex: "",
    },
    [ PacketId.GET_BUILD_INFO ]: {
        year: "",
        month: "",
        day: "",
        increment: "",
        buildType: "",
        dirty: "",
    },
    [ PacketId.READ_MTPA_STATUS ]: {
        mtpa: "",
    },
    [ PacketId.READ_FLUX_WEAKENING_STATUS ]: {
        fluxWeakening: "",
    },
    [ PacketId.WRITE_POSITION_CONTROL_SETTINGS ]: {
        positionControlProportionalGain: "",
        positionControlIntegralGain: "",
        positionControlDerivGain: "",
        positionControlMaxSpeed: "",
        positionControlMaxAccel: "",
        positionControlDeadband: "",
        positionControlType: "",
        positionUnits: "",
        positionResolution: "",
        travelDistance: "",
    },
    [ PacketId.READ_POSITION_CONTROL_SETTINGS ]: {
        positionControlProportionalGain: "",
        positionControlIntegralGain: "",
        positionControlDerivGain: "",
        positionControlMaxSpeed: "",
        positionControlMaxAccel: "",
        positionControlDeadband: "",
        positionControlType: "",
        positionUnits: "",
        positionResolution: "",
        travelDistance: "",
    },
    [ PacketId.SET_POSITION_SENSOR_LIMITS ]: {
        minPosition: "radians",
        maxPosition: "radians",
    },
    [ PacketId.READ_POSITION_SENSOR_LIMITS ]: {
        minValue: "",
        maxValue: "",
    },
    [ PacketId.START_HALL_SENSOR_CAL ]: {
    },
    [ PacketId.GET_HALL_SENSOR_CAL_RESULT ]: {
        forwardOffset: "radians",
        reverseOffset: "radians",
        status: "",
        direction: "",
    },
    [ PacketId.HALL_SENSOR_CAL_RESULT ]: {
        forwardOffset: "radians",
        reverseOffset: "radians",
        status: "",
        direction: "",
    },
    [ PacketId.CLEAR_ALL_FAULTS ]: {
    },
    [ PacketId.CERT_EXCHANGE_1 ]: {
        mcuCertFirstHalf: "",
    },
    [ PacketId.CERT_EXCHANGE_2 ]: {
        result: "",
        mcuCertLastHalf: "",
    },
    [ PacketId.ENC_CHALLENGE_1 ]: {
        encChallengeA: "",
        challengeB: "",
    },
    [ PacketId.ENC_CHALLENGE_2 ]: {
        result: "",
    },
    [ PacketId.KEEP_ALIVE ]: {
        authStatus: "",
    },
    [ PacketId.KEY_CONFIG ]: {
        keyBytestreamRsp: "",
    },
    [ PacketId.START_HOMING_CAL ]: {
    },
    [ PacketId.HOMING_CAL_RESULT ]: {
        zeroOffset: "radians",
        status: "",
    },
    [ PacketId.START_SYSID ]: {
    },
    [ PacketId.STOP_SYSID ]: {
    },
    [ PacketId.ZERO_DARE_SENSOR ]: {
        encoder0ZeroPos: "",
        encoder1ZeroPos: "",
    },
    [ PacketId.READ_TOTAL_ACTUATORS ]: {
        detectedNodes: "",
        expectedNodes: "",
        operationalNodesBitmap: "",
    },
    [ PacketId.ACTUATOR_INFO ]: {
        nodeId: "",
        dispositionStr: "",
    },
    [ PacketId.SET_CONTROL_MODE ]: {
        controlMode: "",
    },
    [ PacketId.SET_USB_THROTTLE_CONTROL ]: {
        value: "",
    },
    [ PacketId.FAULT_DATA ]: {
        code: "",
    },
    [ PacketId.REALTIME_DATA ]: {
        motorSpeed: "RPM",
        motorCurrent: "amps",
        batteryVoltage: "volts",
        batteryCurrent: "amps",
        servoPulse: "",
        inverterTemp: "celsius",
        controllerState: "",
        faultCodeDeprecated: "",
        uptimeMs: "",
        motorPosition: "",
        positionSensorReading: "",
        faultsBitmapLower32: "",
        faultsBitmapUpper16: "",
        externalThermTemp: "celsius",
        rawPositionSensor: "",
        sysidFrequency: "Hz",
        sysidMagnitude: "",
    },
    [ PacketId.VARIABLE_TELEMETRY ]: {
        telemId: "",
        telemBytestream: "",
    },
    [ PacketId.MULTI_MOTOR_TELEMETRY ]: {
        actuatorNodeId: "",
        faultsBitmapLower32: "",
        faultsBitmapUpper16: "",
        currentPosition: "1/10,000ths",
        velocityActualValue: "RPM",
        torqueActualValue: "Newton-meters",
        currentActualValue: "milliamps",
        targetPosition: "1/10,000ths",
        statusWord: "",
        mosfetTemperature: "celsius",
        batteryCurrent: "amps",
    },
    [ PacketId.FIRMWARE_UPDATE ]: {
    },
    [ PacketId.USER_DEFINED ]: {
    },
};

type DisplayColors = { [ I in PacketId ]: { [ K in PacketKeys<I> ]: string } };
export const displayColors: DisplayColors = {
    [ PacketId.INVALID ]: {
    },
    [ PacketId.HANDSHAKE ]: {
        versionMajor: "",
        versionMinor: "",
        versionBuild: "",
        resistance: "",
        ld: "",
        lq: "",
        fluxLinkage: "",
        gitHash: "",
        deviceId1: "",
        deviceId2: "",
        deviceId3: "",
    },
    [ PacketId.START_PARAM_DETECT ]: {
        resistance: "",
        ld: "",
        lq: "",
        fluxLinkage: "",
    },
    [ PacketId.WRITE_INPUT_CONFIG ]: {
        inputLimitUpper: "",
        inputLimitLower: "",
        inputLimitCenter: "",
        inputMode: "",
        alwaysOn: "",
    },
    [ PacketId.WRITE_POWER_CONFIG ]: {
        motorCurrentLimit: "",
        batteryCurrentLimit: "",
        criticalOvervoltageThreshold: "",
        criticalUndervoltageThreshold: "",
        overcurrentThresholdDeprecated: "",
        overtemperatureThreshold: "",
        warningOvervoltageThreshold: "",
        warningUndervoltageThreshold: "",
        warningMotorCurrentThreshold: "",
        criticalMotorCurrentThreshold: "",
    },
    [ PacketId.READ_FAULT ]: {
    },
    [ PacketId.READ_TELEMETRY ]: {
    },
    [ PacketId.READ_MOTOR_PARAM ]: {
    },
    [ PacketId.READ_INPUT_CONFIG ]: {
        inputLimitUpper: "",
        inputLimitLower: "",
        inputLimitCenter: "",
        inputMode: "",
        alwaysOn: "",
    },
    [ PacketId.READ_POWER_CONFIG ]: {
        motorCurrentLimit: "",
        batteryCurrentLimit: "",
        criticalOvervoltageThreshold: "",
        criticalUndervoltageThreshold: "",
        overcurrentThresholdDeprecated: "",
        overtemperatureThreshold: "",
        warningOvervoltageThreshold: "",
        warningUndervoltageThreshold: "",
        warningMotorCurrentThreshold: "",
        criticalMotorCurrentThreshold: "",
    },
    [ PacketId.WRITE_PARAMETERS ]: {
        resistance: "",
        ld: "",
        lq: "",
        fluxLinkage: "",
    },
    [ PacketId.WRITE_CONTROL_CONFIG ]: {
        motorMaxSpeed: "",
        polePairCount: "",
        speedControlProportionalGain: "",
        speedControlIntegralGain: "",
        deprecatedPositionControlProportionalGain: "",
        controlMode: "",
        mtpa: "",
        fluxWeakening: "",
    },
    [ PacketId.WRITE_SENSOR_MODE ]: {
        sensorMode: "",
        encoderCpr: "",
    },
    [ PacketId.READ_SENSOR_MODE ]: {
        sensorMode: "",
        encoderCpr: "",
        encoderOffset: "",
        encoderDirection: "",
        hallsensorForwardOffset: "",
        hallsensorReverseOffset: "",
        hallsensorDirection: "",
    },
    [ PacketId.START_ENCODER_CAL ]: {
    },
    [ PacketId.GET_ENCODER_CAL_RESULT ]: {
        offset: "",
        status: "",
        direction: "",
    },
    [ PacketId.ENCODER_CAL_RESULT ]: {
        offset: "",
        status: "",
        direction: "",
    },
    [ PacketId.WRITE_OPEN_LOOP_CONFIG ]: {
        accelerationRamp: "",
    },
    [ PacketId.READ_CONTROL_MODE ]: {
        controlMode: "",
    },
    [ PacketId.WRITE_CAN_ID ]: {
        canId: "",
    },
    [ PacketId.READ_CAN_ID ]: {
        canId: "",
    },
    [ PacketId.WRITE_ESC_ID ]: {
        escIndex: "",
    },
    [ PacketId.READ_ESC_ID ]: {
        escIndex: "",
    },
    [ PacketId.GET_BUILD_INFO ]: {
        year: "",
        month: "",
        day: "",
        increment: "",
        buildType: "",
        dirty: "",
    },
    [ PacketId.READ_MTPA_STATUS ]: {
        mtpa: "",
    },
    [ PacketId.READ_FLUX_WEAKENING_STATUS ]: {
        fluxWeakening: "",
    },
    [ PacketId.WRITE_POSITION_CONTROL_SETTINGS ]: {
        positionControlProportionalGain: "",
        positionControlIntegralGain: "",
        positionControlDerivGain: "",
        positionControlMaxSpeed: "",
        positionControlMaxAccel: "",
        positionControlDeadband: "",
        positionControlType: "",
        positionUnits: "",
        positionResolution: "",
        travelDistance: "",
    },
    [ PacketId.READ_POSITION_CONTROL_SETTINGS ]: {
        positionControlProportionalGain: "",
        positionControlIntegralGain: "",
        positionControlDerivGain: "",
        positionControlMaxSpeed: "",
        positionControlMaxAccel: "",
        positionControlDeadband: "",
        positionControlType: "",
        positionUnits: "",
        positionResolution: "",
        travelDistance: "",
    },
    [ PacketId.SET_POSITION_SENSOR_LIMITS ]: {
        minPosition: "",
        maxPosition: "",
    },
    [ PacketId.READ_POSITION_SENSOR_LIMITS ]: {
        minValue: "",
        maxValue: "",
    },
    [ PacketId.START_HALL_SENSOR_CAL ]: {
    },
    [ PacketId.GET_HALL_SENSOR_CAL_RESULT ]: {
        forwardOffset: "",
        reverseOffset: "",
        status: "",
        direction: "",
    },
    [ PacketId.HALL_SENSOR_CAL_RESULT ]: {
        forwardOffset: "",
        reverseOffset: "",
        status: "",
        direction: "",
    },
    [ PacketId.CLEAR_ALL_FAULTS ]: {
    },
    [ PacketId.CERT_EXCHANGE_1 ]: {
        mcuCertFirstHalf: "",
    },
    [ PacketId.CERT_EXCHANGE_2 ]: {
        result: "",
        mcuCertLastHalf: "",
    },
    [ PacketId.ENC_CHALLENGE_1 ]: {
        encChallengeA: "",
        challengeB: "",
    },
    [ PacketId.ENC_CHALLENGE_2 ]: {
        result: "",
    },
    [ PacketId.KEEP_ALIVE ]: {
        authStatus: "",
    },
    [ PacketId.KEY_CONFIG ]: {
        keyBytestreamRsp: "",
    },
    [ PacketId.START_HOMING_CAL ]: {
    },
    [ PacketId.HOMING_CAL_RESULT ]: {
        zeroOffset: "",
        status: "",
    },
    [ PacketId.START_SYSID ]: {
    },
    [ PacketId.STOP_SYSID ]: {
    },
    [ PacketId.ZERO_DARE_SENSOR ]: {
        encoder0ZeroPos: "",
        encoder1ZeroPos: "",
    },
    [ PacketId.READ_TOTAL_ACTUATORS ]: {
        detectedNodes: "",
        expectedNodes: "",
        operationalNodesBitmap: "",
    },
    [ PacketId.ACTUATOR_INFO ]: {
        nodeId: "",
        dispositionStr: "",
    },
    [ PacketId.SET_CONTROL_MODE ]: {
        controlMode: "",
    },
    [ PacketId.SET_USB_THROTTLE_CONTROL ]: {
        value: "",
    },
    [ PacketId.FAULT_DATA ]: {
        code: "",
    },
    [ PacketId.REALTIME_DATA ]: {
        motorSpeed: "#f74943",
        motorCurrent: "#f7faa2",
        batteryVoltage: "#2cded8",
        batteryCurrent: "#8d8df0",
        servoPulse: "#efc0fc",
        inverterTemp: "#faa114",
        controllerState: "",
        faultCodeDeprecated: "",
        uptimeMs: "#3dba5b",
        motorPosition: "#9105a3",
        positionSensorReading: "#b169ff",
        faultsBitmapLower32: "",
        faultsBitmapUpper16: "",
        externalThermTemp: "#c28d9f",
        rawPositionSensor: "#86da40",
        sysidFrequency: "#00ff00",
        sysidMagnitude: "#ffff00",
    },
    [ PacketId.VARIABLE_TELEMETRY ]: {
        telemId: "",
        telemBytestream: "",
    },
    [ PacketId.MULTI_MOTOR_TELEMETRY ]: {
        actuatorNodeId: "",
        faultsBitmapLower32: "",
        faultsBitmapUpper16: "",
        currentPosition: "",
        velocityActualValue: "",
        torqueActualValue: "",
        currentActualValue: "",
        targetPosition: "",
        statusWord: "",
        mosfetTemperature: "",
        batteryCurrent: "",
    },
    [ PacketId.FIRMWARE_UPDATE ]: {
    },
    [ PacketId.USER_DEFINED ]: {
    },
};

export const inputReportID = ( dv: DataView ): PacketId => {
    return dv.getUint8( 0 );
};

export const deserialize = ( dv: DataView ): IReceivedPacketTypes[ PacketId ] => {
    switch ( inputReportID( dv ) ) {
        case PacketId.INVALID: return deserializeInvalidResponse( dv );
        case PacketId.HANDSHAKE: return deserializeHandshakeResponse( dv );
        case PacketId.START_PARAM_DETECT: return deserializeStartParamDetectResponse( dv );
        case PacketId.WRITE_INPUT_CONFIG: return deserializeWriteInputConfigResponse( dv );
        case PacketId.WRITE_POWER_CONFIG: return deserializeWritePowerConfigResponse( dv );
        case PacketId.READ_FAULT: return deserializeReadFaultResponse( dv );
        case PacketId.READ_TELEMETRY: return deserializeReadTelemetryResponse( dv );
        case PacketId.READ_MOTOR_PARAM: return deserializeReadMotorParamResponse( dv );
        case PacketId.READ_INPUT_CONFIG: return deserializeReadInputConfigResponse( dv );
        case PacketId.READ_POWER_CONFIG: return deserializeReadPowerConfigResponse( dv );
        case PacketId.WRITE_PARAMETERS: return deserializeWriteParametersResponse( dv );
        case PacketId.WRITE_CONTROL_CONFIG: return deserializeWriteControlConfigResponse( dv );
        case PacketId.WRITE_SENSOR_MODE: return deserializeWriteSensorModeResponse( dv );
        case PacketId.READ_SENSOR_MODE: return deserializeReadSensorModeResponse( dv );
        case PacketId.START_ENCODER_CAL: return deserializeStartEncoderCalResponse( dv );
        case PacketId.GET_ENCODER_CAL_RESULT: return deserializeGetEncoderCalResultResponse( dv );
        case PacketId.ENCODER_CAL_RESULT: return deserializeEncoderCalResultResponse( dv );
        case PacketId.WRITE_OPEN_LOOP_CONFIG: return deserializeWriteOpenLoopConfigResponse( dv );
        case PacketId.READ_CONTROL_MODE: return deserializeReadControlModeResponse( dv );
        case PacketId.WRITE_CAN_ID: return deserializeWriteCanIdResponse( dv );
        case PacketId.READ_CAN_ID: return deserializeReadCanIdResponse( dv );
        case PacketId.WRITE_ESC_ID: return deserializeWriteEscIdResponse( dv );
        case PacketId.READ_ESC_ID: return deserializeReadEscIdResponse( dv );
        case PacketId.GET_BUILD_INFO: return deserializeGetBuildInfoResponse( dv );
        case PacketId.READ_MTPA_STATUS: return deserializeReadMtpaStatusResponse( dv );
        case PacketId.READ_FLUX_WEAKENING_STATUS: return deserializeReadFluxWeakeningStatusResponse( dv );
        case PacketId.WRITE_POSITION_CONTROL_SETTINGS: return deserializeWritePositionControlSettingsResponse( dv );
        case PacketId.READ_POSITION_CONTROL_SETTINGS: return deserializeReadPositionControlSettingsResponse( dv );
        case PacketId.SET_POSITION_SENSOR_LIMITS: return deserializeSetPositionSensorLimitsResponse( dv );
        case PacketId.READ_POSITION_SENSOR_LIMITS: return deserializeReadPositionSensorLimitsResponse( dv );
        case PacketId.START_HALL_SENSOR_CAL: return deserializeStartHallSensorCalResponse( dv );
        case PacketId.GET_HALL_SENSOR_CAL_RESULT: return deserializeGetHallSensorCalResultResponse( dv );
        case PacketId.HALL_SENSOR_CAL_RESULT: return deserializeHallSensorCalResultResponse( dv );
        case PacketId.CLEAR_ALL_FAULTS: return deserializeClearAllFaultsResponse( dv );
        case PacketId.CERT_EXCHANGE_1: return deserializeCertExchange1Response( dv );
        case PacketId.CERT_EXCHANGE_2: return deserializeCertExchange2Response( dv );
        case PacketId.ENC_CHALLENGE_1: return deserializeEncChallenge1Response( dv );
        case PacketId.ENC_CHALLENGE_2: return deserializeEncChallenge2Response( dv );
        case PacketId.KEEP_ALIVE: return deserializeKeepAliveResponse( dv );
        case PacketId.KEY_CONFIG: return deserializeKeyConfigResponse( dv );
        case PacketId.START_HOMING_CAL: return deserializeStartHomingCalResponse( dv );
        case PacketId.HOMING_CAL_RESULT: return deserializeHomingCalResultResponse( dv );
        case PacketId.START_SYSID: return deserializeStartSysidResponse( dv );
        case PacketId.STOP_SYSID: return deserializeStopSysidResponse( dv );
        case PacketId.ZERO_DARE_SENSOR: return deserializeZeroDareSensorResponse( dv );
        case PacketId.READ_TOTAL_ACTUATORS: return deserializeReadTotalActuatorsResponse( dv );
        case PacketId.ACTUATOR_INFO: return deserializeActuatorInfoResponse( dv );
        case PacketId.SET_CONTROL_MODE: return deserializeSetControlModeResponse( dv );
        case PacketId.SET_USB_THROTTLE_CONTROL: return deserializeSetUsbThrottleControlResponse( dv );
        case PacketId.FAULT_DATA: return deserializeFaultDataMessage( dv );
        case PacketId.REALTIME_DATA: return deserializeRealtimeDataMessage( dv );
        case PacketId.VARIABLE_TELEMETRY: return deserializeVariableTelemetryMessage( dv );
        case PacketId.MULTI_MOTOR_TELEMETRY: return deserializeMultiMotorTelemetryMessage( dv );
        case PacketId.FIRMWARE_UPDATE: return deserializeFirmwareUpdateResponse( dv );
        case PacketId.USER_DEFINED: return deserializeUserDefinedMessage( dv );
    }
};
